/* eslint-disable */
// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.5
// Generated from `Act2021DriverServant.jce'
// **********************************************************************

var HUYA = HUYA || {};


HUYA.EGender = 
{
    MALE: 0,
    FEMALE: 1
};


HUYA.BulletBorderGroundFormat = function()
{
    this.iEnableUse = 0;
    this.iBorderThickness = 0;
    this.iBorderColour = -1;
    this.iBorderDiaphaneity = 100;
    this.iGroundColour = -1;
    this.iGroundColourDiaphaneity = 100;
    this.sAvatarDecorationUrl = "";
    this.iFontColor = -1;
    this.iTerminalFlag = -1;
};
HUYA.BulletBorderGroundFormat.prototype._clone = function () { return new HUYA.BulletBorderGroundFormat(); }
HUYA.BulletBorderGroundFormat.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BulletBorderGroundFormat.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BulletBorderGroundFormat.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iEnableUse);
    os.writeInt32(1, this.iBorderThickness);
    os.writeInt32(2, this.iBorderColour);
    os.writeInt32(3, this.iBorderDiaphaneity);
    os.writeInt32(4, this.iGroundColour);
    os.writeInt32(5, this.iGroundColourDiaphaneity);
    os.writeString(6, this.sAvatarDecorationUrl);
    os.writeInt32(7, this.iFontColor);
    os.writeInt32(8, this.iTerminalFlag);
};

HUYA.BulletBorderGroundFormat.prototype.readFrom = function (is)
{
    this.iEnableUse= is.readInt32(0, false, this.iEnableUse);
    this.iBorderThickness= is.readInt32(1, false, this.iBorderThickness);
    this.iBorderColour= is.readInt32(2, false, this.iBorderColour);
    this.iBorderDiaphaneity= is.readInt32(3, false, this.iBorderDiaphaneity);
    this.iGroundColour= is.readInt32(4, false, this.iGroundColour);
    this.iGroundColourDiaphaneity= is.readInt32(5, false, this.iGroundColourDiaphaneity);
    this.sAvatarDecorationUrl= is.readString(6, false, this.sAvatarDecorationUrl);
    this.iFontColor= is.readInt32(7, false, this.iFontColor);
    this.iTerminalFlag= is.readInt32(8, false, this.iTerminalFlag);
};

HUYA.FaithPresenter = function()
{
    this.lPid = 0;
    this.sLogo = "";
};
HUYA.FaithPresenter.prototype._clone = function () { return new HUYA.FaithPresenter(); }
HUYA.FaithPresenter.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.FaithPresenter.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.FaithPresenter.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeString(1, this.sLogo);
};

HUYA.FaithPresenter.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.sLogo= is.readString(1, false, this.sLogo);
};

HUYA.LiveAttributeInfo = function()
{
    this.vData = new Taf.BinBuffer();
    this.lTimespan = 0;
    this.lExpTimeMs = 0;
};
HUYA.LiveAttributeInfo.prototype._clone = function () { return new HUYA.LiveAttributeInfo(); }
HUYA.LiveAttributeInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveAttributeInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.LiveAttributeInfo.prototype.writeTo = function (os)
{
    os.writeBytes(0, this.vData);
    os.writeInt64(1, this.lTimespan);
    os.writeInt64(2, this.lExpTimeMs);
};

HUYA.LiveAttributeInfo.prototype.readFrom = function (is)
{
    this.vData= is.readBytes(0, false, this.vData);
    this.lTimespan= is.readInt64(1, false, this.lTimespan);
    this.lExpTimeMs= is.readInt64(2, false, this.lExpTimeMs);
};

HUYA.GameLiveTag = function()
{
    this.iTagId = 0;
    this.sTagName = "";
    this.bIsShow = true;
    this.iBindingGameId = 0;
    this.iShowType = 0;
};
HUYA.GameLiveTag.prototype._clone = function () { return new HUYA.GameLiveTag(); }
HUYA.GameLiveTag.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GameLiveTag.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GameLiveTag.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iTagId);
    os.writeString(1, this.sTagName);
    os.writeBoolean(2, this.bIsShow);
    os.writeInt32(3, this.iBindingGameId);
    os.writeInt32(4, this.iShowType);
};

HUYA.GameLiveTag.prototype.readFrom = function (is)
{
    this.iTagId= is.readInt32(0, false, this.iTagId);
    this.sTagName= is.readString(1, false, this.sTagName);
    this.bIsShow= is.readBoolean(2, false, this.bIsShow);
    this.iBindingGameId= is.readInt32(3, false, this.iBindingGameId);
    this.iShowType= is.readInt32(4, false, this.iShowType);
};

HUYA.NoblePetAttr = function()
{
    this.iPetId = 0;
    this.sPetName = "";
    this.sPetAction = "";
    this.iFrame = 0;
    this.iBeginTime = 0;
    this.iEndTime = 0;
};
HUYA.NoblePetAttr.prototype._clone = function () { return new HUYA.NoblePetAttr(); }
HUYA.NoblePetAttr.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.NoblePetAttr.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.NoblePetAttr.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iPetId);
    os.writeString(1, this.sPetName);
    os.writeString(2, this.sPetAction);
    os.writeInt32(3, this.iFrame);
    os.writeInt32(4, this.iBeginTime);
    os.writeInt32(5, this.iEndTime);
};

HUYA.NoblePetAttr.prototype.readFrom = function (is)
{
    this.iPetId= is.readInt32(0, false, this.iPetId);
    this.sPetName= is.readString(1, false, this.sPetName);
    this.sPetAction= is.readString(2, false, this.sPetAction);
    this.iFrame= is.readInt32(3, false, this.iFrame);
    this.iBeginTime= is.readInt32(4, false, this.iBeginTime);
    this.iEndTime= is.readInt32(5, false, this.iEndTime);
};

HUYA.NobleLevelAttr = function()
{
    this.iAttrType = 0;
    this.lValidDate = 0;
    this.iAttrStatus = 0;
    this.iProgress = 0;
    this.iTask = 0;
    this.iRemainDays = 0;
    this.sReserve = "";
};
HUYA.NobleLevelAttr.prototype._clone = function () { return new HUYA.NobleLevelAttr(); }
HUYA.NobleLevelAttr.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.NobleLevelAttr.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.NobleLevelAttr.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAttrType);
    os.writeInt64(1, this.lValidDate);
    os.writeInt32(2, this.iAttrStatus);
    os.writeInt32(3, this.iProgress);
    os.writeInt32(4, this.iTask);
    os.writeInt32(5, this.iRemainDays);
    os.writeString(6, this.sReserve);
};

HUYA.NobleLevelAttr.prototype.readFrom = function (is)
{
    this.iAttrType= is.readInt32(0, false, this.iAttrType);
    this.lValidDate= is.readInt64(1, false, this.lValidDate);
    this.iAttrStatus= is.readInt32(2, false, this.iAttrStatus);
    this.iProgress= is.readInt32(3, false, this.iProgress);
    this.iTask= is.readInt32(4, false, this.iTask);
    this.iRemainDays= is.readInt32(5, false, this.iRemainDays);
    this.sReserve= is.readString(6, false, this.sReserve);
};

HUYA.NobleLevelInfo = function()
{
    this.iNobleLevel = 0;
    this.iAttrType = 0;
};
HUYA.NobleLevelInfo.prototype._clone = function () { return new HUYA.NobleLevelInfo(); }
HUYA.NobleLevelInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.NobleLevelInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.NobleLevelInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iNobleLevel);
    os.writeInt32(1, this.iAttrType);
};

HUYA.NobleLevelInfo.prototype.readFrom = function (is)
{
    this.iNobleLevel= is.readInt32(0, false, this.iNobleLevel);
    this.iAttrType= is.readInt32(1, false, this.iAttrType);
};

HUYA.UserId = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sToken = "";
    this.sHuYaUA = "";
    this.sCookie = "";
    this.iTokenType = 0;
    this.sDeviceInfo = "";
};
HUYA.UserId.prototype._clone = function () { return new HUYA.UserId(); }
HUYA.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserId.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserId.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sToken);
    os.writeString(3, this.sHuYaUA);
    os.writeString(4, this.sCookie);
    os.writeInt32(5, this.iTokenType);
    os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sToken= is.readString(2, false, this.sToken);
    this.sHuYaUA= is.readString(3, false, this.sHuYaUA);
    this.sCookie= is.readString(4, false, this.sCookie);
    this.iTokenType= is.readInt32(5, false, this.iTokenType);
    this.sDeviceInfo= is.readString(6, false, this.sDeviceInfo);
};

HUYA.UidNickName = function()
{
    this.lUid = 0;
    this.sNickName = "";
};
HUYA.UidNickName.prototype._clone = function () { return new HUYA.UidNickName(); }
HUYA.UidNickName.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UidNickName.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UidNickName.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
};

HUYA.UidNickName.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
};

HUYA.SendMessageFormat = function()
{
    this.iSenceType = 0;
    this.lFormatId = 0;
};
HUYA.SendMessageFormat.prototype._clone = function () { return new HUYA.SendMessageFormat(); }
HUYA.SendMessageFormat.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SendMessageFormat.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SendMessageFormat.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iSenceType);
    os.writeInt64(1, this.lFormatId);
};

HUYA.SendMessageFormat.prototype.readFrom = function (is)
{
    this.iSenceType= is.readInt32(0, false, this.iSenceType);
    this.lFormatId= is.readInt64(1, false, this.lFormatId);
};

HUYA.MessageTagInfo = function()
{
    this.iAppId = 0;
    this.sTag = "";
};
HUYA.MessageTagInfo.prototype._clone = function () { return new HUYA.MessageTagInfo(); }
HUYA.MessageTagInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MessageTagInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MessageTagInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAppId);
    os.writeString(1, this.sTag);
};

HUYA.MessageTagInfo.prototype.readFrom = function (is)
{
    this.iAppId= is.readInt32(0, false, this.iAppId);
    this.sTag= is.readString(1, false, this.sTag);
};

HUYA.ContentFormat = function()
{
    this.iFontColor = -1;
    this.iFontSize = 4;
    this.iPopupStyle = 0;
    this.iNickNameFontColor = -1;
    this.iDarkFontColor = -1;
    this.iDarkNickNameFontColor = -1;
};
HUYA.ContentFormat.prototype._clone = function () { return new HUYA.ContentFormat(); }
HUYA.ContentFormat.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ContentFormat.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ContentFormat.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iFontColor);
    os.writeInt32(1, this.iFontSize);
    os.writeInt32(2, this.iPopupStyle);
    os.writeInt32(3, this.iNickNameFontColor);
    os.writeInt32(4, this.iDarkFontColor);
    os.writeInt32(5, this.iDarkNickNameFontColor);
};

HUYA.ContentFormat.prototype.readFrom = function (is)
{
    this.iFontColor= is.readInt32(0, false, this.iFontColor);
    this.iFontSize= is.readInt32(1, false, this.iFontSize);
    this.iPopupStyle= is.readInt32(2, false, this.iPopupStyle);
    this.iNickNameFontColor= is.readInt32(3, false, this.iNickNameFontColor);
    this.iDarkFontColor= is.readInt32(4, false, this.iDarkFontColor);
    this.iDarkNickNameFontColor= is.readInt32(5, false, this.iDarkNickNameFontColor);
};

HUYA.BulletFormat = function()
{
    this.iFontColor = -1;
    this.iFontSize = 4;
    this.iTextSpeed = 0;
    this.iTransitionType = 1;
    this.iPopupStyle = 0;
    this.tBorderGroundFormat = new HUYA.BulletBorderGroundFormat();
    this.vGraduatedColor = new Taf.Vector(new Taf.INT32());
    this.iAvatarFlag = 0;
    this.iAvatarTerminalFlag = -1;
};
HUYA.BulletFormat.prototype._clone = function () { return new HUYA.BulletFormat(); }
HUYA.BulletFormat.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BulletFormat.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BulletFormat.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iFontColor);
    os.writeInt32(1, this.iFontSize);
    os.writeInt32(2, this.iTextSpeed);
    os.writeInt32(3, this.iTransitionType);
    os.writeInt32(4, this.iPopupStyle);
    os.writeStruct(5, this.tBorderGroundFormat);
    os.writeVector(6, this.vGraduatedColor);
    os.writeInt32(7, this.iAvatarFlag);
    os.writeInt32(8, this.iAvatarTerminalFlag);
};

HUYA.BulletFormat.prototype.readFrom = function (is)
{
    this.iFontColor= is.readInt32(0, false, this.iFontColor);
    this.iFontSize= is.readInt32(1, false, this.iFontSize);
    this.iTextSpeed= is.readInt32(2, false, this.iTextSpeed);
    this.iTransitionType= is.readInt32(3, false, this.iTransitionType);
    this.iPopupStyle= is.readInt32(4, false, this.iPopupStyle);
    this.tBorderGroundFormat= is.readStruct(5, false, this.tBorderGroundFormat);
    this.vGraduatedColor= is.readVector(6, false, this.vGraduatedColor);
    this.iAvatarFlag= is.readInt32(7, false, this.iAvatarFlag);
    this.iAvatarTerminalFlag= is.readInt32(8, false, this.iAvatarTerminalFlag);
};

HUYA.SuperFansInfo = function()
{
    this.lSFExpiredTS = 0;
    this.iSFFlag = 0;
    this.lSFAnnualTS = 0;
};
HUYA.SuperFansInfo.prototype._clone = function () { return new HUYA.SuperFansInfo(); }
HUYA.SuperFansInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SuperFansInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SuperFansInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lSFExpiredTS);
    os.writeInt32(1, this.iSFFlag);
    os.writeInt64(2, this.lSFAnnualTS);
};

HUYA.SuperFansInfo.prototype.readFrom = function (is)
{
    this.lSFExpiredTS= is.readInt64(0, false, this.lSFExpiredTS);
    this.iSFFlag= is.readInt32(1, false, this.iSFFlag);
    this.lSFAnnualTS= is.readInt64(2, false, this.lSFAnnualTS);
};

HUYA.PresenterChannelInfo = function()
{
    this.lYYId = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.iSourceType = 0;
    this.iScreenType = 0;
    this.lUid = 0;
    this.iGameId = 0;
    this.iRoomId = 0;
};
HUYA.PresenterChannelInfo.prototype._clone = function () { return new HUYA.PresenterChannelInfo(); }
HUYA.PresenterChannelInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterChannelInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterChannelInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lYYId);
    os.writeInt64(1, this.lTid);
    os.writeInt64(3, this.lSid);
    os.writeInt32(4, this.iSourceType);
    os.writeInt32(5, this.iScreenType);
    os.writeInt64(6, this.lUid);
    os.writeInt32(7, this.iGameId);
    os.writeInt32(8, this.iRoomId);
};

HUYA.PresenterChannelInfo.prototype.readFrom = function (is)
{
    this.lYYId= is.readInt64(0, false, this.lYYId);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(3, false, this.lSid);
    this.iSourceType= is.readInt32(4, false, this.iSourceType);
    this.iScreenType= is.readInt32(5, false, this.iScreenType);
    this.lUid= is.readInt64(6, false, this.lUid);
    this.iGameId= is.readInt32(7, false, this.iGameId);
    this.iRoomId= is.readInt32(8, false, this.iRoomId);
};

HUYA.FaithInfo = function()
{
    this.sFaithName = "";
    this.vPresenter = new Taf.Vector(new HUYA.FaithPresenter());
};
HUYA.FaithInfo.prototype._clone = function () { return new HUYA.FaithInfo(); }
HUYA.FaithInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.FaithInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.FaithInfo.prototype.writeTo = function (os)
{
    os.writeString(0, this.sFaithName);
    os.writeVector(1, this.vPresenter);
};

HUYA.FaithInfo.prototype.readFrom = function (is)
{
    this.sFaithName= is.readString(0, false, this.sFaithName);
    this.vPresenter= is.readVector(1, false, this.vPresenter);
};

HUYA.GameLiveMisc = function()
{
    this.mMiscInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING());
    this.sIP = "";
    this.sGuid = "";
    this.iPresentType = 0;
    this.sGPSInfo = "";
    this.lBonusValue = 0;
    this.sIPLocation = "";
    this.sHuYaUA = "";
    this.iScore = 0;
    this.lRealAttendeeCount = 0;
    this.lSubscribedCount = 0;
    this.mpAttribute = new Taf.Map(new Taf.STRING(), new HUYA.LiveAttributeInfo());
    this.sPassword = "";
};
HUYA.GameLiveMisc.prototype._clone = function () { return new HUYA.GameLiveMisc(); }
HUYA.GameLiveMisc.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GameLiveMisc.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GameLiveMisc.prototype.writeTo = function (os)
{
    os.writeMap(0, this.mMiscInfo);
    os.writeString(1, this.sIP);
    os.writeString(2, this.sGuid);
    os.writeInt32(3, this.iPresentType);
    os.writeString(4, this.sGPSInfo);
    os.writeInt64(5, this.lBonusValue);
    os.writeString(6, this.sIPLocation);
    os.writeString(7, this.sHuYaUA);
    os.writeInt64(8, this.iScore);
    os.writeInt64(9, this.lRealAttendeeCount);
    os.writeInt64(10, this.lSubscribedCount);
    os.writeMap(11, this.mpAttribute);
    os.writeString(12, this.sPassword);
};

HUYA.GameLiveMisc.prototype.readFrom = function (is)
{
    this.mMiscInfo= is.readMap(0, false, this.mMiscInfo);
    this.sIP= is.readString(1, false, this.sIP);
    this.sGuid= is.readString(2, false, this.sGuid);
    this.iPresentType= is.readInt32(3, false, this.iPresentType);
    this.sGPSInfo= is.readString(4, false, this.sGPSInfo);
    this.lBonusValue= is.readInt64(5, false, this.lBonusValue);
    this.sIPLocation= is.readString(6, false, this.sIPLocation);
    this.sHuYaUA= is.readString(7, false, this.sHuYaUA);
    this.iScore= is.readInt64(8, false, this.iScore);
    this.lRealAttendeeCount= is.readInt64(9, false, this.lRealAttendeeCount);
    this.lSubscribedCount= is.readInt64(10, false, this.lSubscribedCount);
    this.mpAttribute= is.readMap(11, false, this.mpAttribute);
    this.sPassword= is.readString(12, false, this.sPassword);
};

HUYA.GameLiveInfo = function()
{
    this.lLiveId = 0;
    this.lUid = 0;
    this.lChannelId = 0;
    this.iShortChannel = 0;
    this.lSubchannel = 0;
    this.sSubchannelName = "";
    this.iGameId = 0;
    this.sGameName = "";
    this.iAttendeeCount = 0;
    this.eGender = HUYA.EGender.MALE;
    this.iAid = 0;
    this.sNick = "";
    this.sAvatarUrl = "";
    this.iStartTime = 0;
    this.iEndTime = 0;
    this.iSourceType = 0;
    this.bIsCameraOpen = false;
    this.bIsRoomSecret = false;
    this.sVideoCaptureUrl = "";
    this.iCdnAttendee = 0;
    this.lYYId = 0;
    this.bCertified = false;
    this.iRecType = 0;
    this.lSignChannel = 0;
    this.sLiveDesc = "";
    this.iLevel = 0;
    this.sGameShortName = "";
    this.iGameType = 0;
    this.sPrivateHost = "";
    this.iActivityCount = 0;
    this.iStreamType = 0;
    this.iBitRate = 0;
    this.iResolution = 0;
    this.iFrameRate = 0;
    this.iIsMultiStream = 0;
    this.iExeGameId = 0;
    this.lExp = 0;
    this.sReplayHls = "";
    this.lMultiStreamFlag = 0;
    this.iScreenType = 0;
    this.iChannelType = 0;
    this.sLocation = "";
    this.iCodecType = 0;
    this.vPresenterTags = new Taf.Vector(new HUYA.GameLiveTag());
    this.vGameTags = new Taf.Vector(new HUYA.GameLiveTag());
    this.lLiveCompatibleFlag = 0;
    this.sTraceId = "";
    this.iRoomId = 0;
};
HUYA.GameLiveInfo.prototype._clone = function () { return new HUYA.GameLiveInfo(); }
HUYA.GameLiveInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GameLiveInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GameLiveInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lLiveId);
    os.writeInt64(1, this.lUid);
    os.writeInt64(2, this.lChannelId);
    os.writeInt32(3, this.iShortChannel);
    os.writeInt64(4, this.lSubchannel);
    os.writeString(5, this.sSubchannelName);
    os.writeInt32(6, this.iGameId);
    os.writeString(7, this.sGameName);
    os.writeInt32(8, this.iAttendeeCount);
    os.writeInt32(9, this.eGender);
    os.writeInt32(10, this.iAid);
    os.writeString(11, this.sNick);
    os.writeString(12, this.sAvatarUrl);
    os.writeInt32(13, this.iStartTime);
    os.writeInt32(14, this.iEndTime);
    os.writeInt32(15, this.iSourceType);
    os.writeBoolean(16, this.bIsCameraOpen);
    os.writeBoolean(17, this.bIsRoomSecret);
    os.writeString(18, this.sVideoCaptureUrl);
    os.writeInt32(19, this.iCdnAttendee);
    os.writeInt64(20, this.lYYId);
    os.writeBoolean(21, this.bCertified);
    os.writeInt32(22, this.iRecType);
    os.writeInt64(23, this.lSignChannel);
    os.writeString(24, this.sLiveDesc);
    os.writeInt32(25, this.iLevel);
    os.writeString(26, this.sGameShortName);
    os.writeInt32(27, this.iGameType);
    os.writeString(28, this.sPrivateHost);
    os.writeInt32(29, this.iActivityCount);
    os.writeInt32(30, this.iStreamType);
    os.writeInt32(31, this.iBitRate);
    os.writeInt32(32, this.iResolution);
    os.writeInt32(33, this.iFrameRate);
    os.writeInt32(34, this.iIsMultiStream);
    os.writeInt32(35, this.iExeGameId);
    os.writeInt64(36, this.lExp);
    os.writeString(37, this.sReplayHls);
    os.writeInt64(38, this.lMultiStreamFlag);
    os.writeInt32(39, this.iScreenType);
    os.writeInt32(40, this.iChannelType);
    os.writeString(41, this.sLocation);
    os.writeInt32(42, this.iCodecType);
    os.writeVector(43, this.vPresenterTags);
    os.writeVector(44, this.vGameTags);
    os.writeInt64(45, this.lLiveCompatibleFlag);
    os.writeString(46, this.sTraceId);
    os.writeInt32(47, this.iRoomId);
};

HUYA.GameLiveInfo.prototype.readFrom = function (is)
{
    this.lLiveId= is.readInt64(0, false, this.lLiveId);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.lChannelId= is.readInt64(2, false, this.lChannelId);
    this.iShortChannel= is.readInt32(3, false, this.iShortChannel);
    this.lSubchannel= is.readInt64(4, false, this.lSubchannel);
    this.sSubchannelName= is.readString(5, false, this.sSubchannelName);
    this.iGameId= is.readInt32(6, false, this.iGameId);
    this.sGameName= is.readString(7, false, this.sGameName);
    this.iAttendeeCount= is.readInt32(8, false, this.iAttendeeCount);
    this.eGender= is.readInt32(9, false, this.eGender);
    this.iAid= is.readInt32(10, false, this.iAid);
    this.sNick= is.readString(11, false, this.sNick);
    this.sAvatarUrl= is.readString(12, false, this.sAvatarUrl);
    this.iStartTime= is.readInt32(13, false, this.iStartTime);
    this.iEndTime= is.readInt32(14, false, this.iEndTime);
    this.iSourceType= is.readInt32(15, false, this.iSourceType);
    this.bIsCameraOpen= is.readBoolean(16, false, this.bIsCameraOpen);
    this.bIsRoomSecret= is.readBoolean(17, false, this.bIsRoomSecret);
    this.sVideoCaptureUrl= is.readString(18, false, this.sVideoCaptureUrl);
    this.iCdnAttendee= is.readInt32(19, false, this.iCdnAttendee);
    this.lYYId= is.readInt64(20, false, this.lYYId);
    this.bCertified= is.readBoolean(21, false, this.bCertified);
    this.iRecType= is.readInt32(22, false, this.iRecType);
    this.lSignChannel= is.readInt64(23, false, this.lSignChannel);
    this.sLiveDesc= is.readString(24, false, this.sLiveDesc);
    this.iLevel= is.readInt32(25, false, this.iLevel);
    this.sGameShortName= is.readString(26, false, this.sGameShortName);
    this.iGameType= is.readInt32(27, false, this.iGameType);
    this.sPrivateHost= is.readString(28, false, this.sPrivateHost);
    this.iActivityCount= is.readInt32(29, false, this.iActivityCount);
    this.iStreamType= is.readInt32(30, false, this.iStreamType);
    this.iBitRate= is.readInt32(31, false, this.iBitRate);
    this.iResolution= is.readInt32(32, false, this.iResolution);
    this.iFrameRate= is.readInt32(33, false, this.iFrameRate);
    this.iIsMultiStream= is.readInt32(34, false, this.iIsMultiStream);
    this.iExeGameId= is.readInt32(35, false, this.iExeGameId);
    this.lExp= is.readInt64(36, false, this.lExp);
    this.sReplayHls= is.readString(37, false, this.sReplayHls);
    this.lMultiStreamFlag= is.readInt64(38, false, this.lMultiStreamFlag);
    this.iScreenType= is.readInt32(39, false, this.iScreenType);
    this.iChannelType= is.readInt32(40, false, this.iChannelType);
    this.sLocation= is.readString(41, false, this.sLocation);
    this.iCodecType= is.readInt32(42, false, this.iCodecType);
    this.vPresenterTags= is.readVector(43, false, this.vPresenterTags);
    this.vGameTags= is.readVector(44, false, this.vGameTags);
    this.lLiveCompatibleFlag= is.readInt64(45, false, this.lLiveCompatibleFlag);
    this.sTraceId= is.readString(46, false, this.sTraceId);
    this.iRoomId= is.readInt32(47, false, this.iRoomId);
};

HUYA.NobleInfo = function()
{
    this.lUid = 0;
    this.lPid = 0;
    this.lValidDate = 0;
    this.sNobleName = "";
    this.iNobleLevel = 0;
    this.iNoblePet = 0;
    this.iNobleStatus = 0;
    this.iNobleType = 0;
    this.iRemainDays = 0;
    this.tLevelAttr = new HUYA.NobleLevelAttr();
    this.tPetAttr = new HUYA.NoblePetAttr();
    this.lOpenTime = 0;
};
HUYA.NobleInfo.prototype._clone = function () { return new HUYA.NobleInfo(); }
HUYA.NobleInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.NobleInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.NobleInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lPid);
    os.writeInt64(2, this.lValidDate);
    os.writeString(3, this.sNobleName);
    os.writeInt32(4, this.iNobleLevel);
    os.writeInt32(5, this.iNoblePet);
    os.writeInt32(6, this.iNobleStatus);
    os.writeInt32(7, this.iNobleType);
    os.writeInt32(8, this.iRemainDays);
    os.writeStruct(9, this.tLevelAttr);
    os.writeStruct(10, this.tPetAttr);
    os.writeInt64(11, this.lOpenTime);
};

HUYA.NobleInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lPid= is.readInt64(1, false, this.lPid);
    this.lValidDate= is.readInt64(2, false, this.lValidDate);
    this.sNobleName= is.readString(3, false, this.sNobleName);
    this.iNobleLevel= is.readInt32(4, false, this.iNobleLevel);
    this.iNoblePet= is.readInt32(5, false, this.iNoblePet);
    this.iNobleStatus= is.readInt32(6, false, this.iNobleStatus);
    this.iNobleType= is.readInt32(7, false, this.iNobleType);
    this.iRemainDays= is.readInt32(8, false, this.iRemainDays);
    this.tLevelAttr= is.readStruct(9, false, this.tLevelAttr);
    this.tPetAttr= is.readStruct(10, false, this.tPetAttr);
    this.lOpenTime= is.readInt64(11, false, this.lOpenTime);
};

HUYA.SenderInfo = function()
{
    this.lUid = 0;
    this.lImid = 0;
    this.sNickName = "";
    this.iGender = 0;
    this.sAvatarUrl = "";
    this.iNobleLevel = 0;
    this.tNobleLevelInfo = new HUYA.NobleLevelInfo();
    this.sGuid = "";
    this.sHuYaUA = "";
};
HUYA.SenderInfo.prototype._clone = function () { return new HUYA.SenderInfo(); }
HUYA.SenderInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SenderInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SenderInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lImid);
    os.writeString(2, this.sNickName);
    os.writeInt32(3, this.iGender);
    os.writeString(4, this.sAvatarUrl);
    os.writeInt32(5, this.iNobleLevel);
    os.writeStruct(6, this.tNobleLevelInfo);
    os.writeString(7, this.sGuid);
    os.writeString(8, this.sHuYaUA);
};

HUYA.SenderInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lImid= is.readInt64(1, false, this.lImid);
    this.sNickName= is.readString(2, false, this.sNickName);
    this.iGender= is.readInt32(3, false, this.iGender);
    this.sAvatarUrl= is.readString(4, false, this.sAvatarUrl);
    this.iNobleLevel= is.readInt32(5, false, this.iNobleLevel);
    this.tNobleLevelInfo= is.readStruct(6, false, this.tNobleLevelInfo);
    this.sGuid= is.readString(7, false, this.sGuid);
    this.sHuYaUA= is.readString(8, false, this.sHuYaUA);
};

HUYA.DecorationInfo = function()
{
    this.iAppId = 0;
    this.iViewType = 0;
    this.vData = new Taf.BinBuffer();
    this.lSourceId = 0;
    this.iType = 0;
};
HUYA.DecorationInfo.prototype._clone = function () { return new HUYA.DecorationInfo(); }
HUYA.DecorationInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.DecorationInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.DecorationInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAppId);
    os.writeInt32(1, this.iViewType);
    os.writeBytes(2, this.vData);
    os.writeInt64(3, this.lSourceId);
    os.writeInt32(4, this.iType);
};

HUYA.DecorationInfo.prototype.readFrom = function (is)
{
    this.iAppId= is.readInt32(0, false, this.iAppId);
    this.iViewType= is.readInt32(1, false, this.iViewType);
    this.vData= is.readBytes(2, false, this.vData);
    this.lSourceId= is.readInt64(3, false, this.lSourceId);
    this.iType= is.readInt32(4, false, this.iType);
};

HUYA.ChannelPair = function()
{
    this.lTid = 0;
    this.lSid = 0;
    this.lPid = 0;
};
HUYA.ChannelPair.prototype._clone = function () { return new HUYA.ChannelPair(); }
HUYA.ChannelPair.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ChannelPair.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ChannelPair.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lTid);
    os.writeInt64(1, this.lSid);
    os.writeInt64(2, this.lPid);
};

HUYA.ChannelPair.prototype.readFrom = function (is)
{
    this.lTid= is.readInt64(0, false, this.lTid);
    this.lSid= is.readInt64(1, false, this.lSid);
    this.lPid= is.readInt64(2, false, this.lPid);
};

HUYA.SendMessageReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.lTid = 0;
    this.lSid = 0;
    this.sContent = "";
    this.iShowMode = 0;
    this.tFormat = new HUYA.ContentFormat();
    this.tBulletFormat = new HUYA.BulletFormat();
    this.vAtSomeone = new Taf.Vector(new HUYA.UidNickName());
    this.lPid = 0;
    this.vTagInfo = new Taf.Vector(new HUYA.MessageTagInfo());
    this.tSenceFormat = new HUYA.SendMessageFormat();
};
HUYA.SendMessageReq.prototype._clone = function () { return new HUYA.SendMessageReq(); }
HUYA.SendMessageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SendMessageReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SendMessageReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserId);
    os.writeInt64(1, this.lTid);
    os.writeInt64(2, this.lSid);
    os.writeString(3, this.sContent);
    os.writeInt32(4, this.iShowMode);
    os.writeStruct(5, this.tFormat);
    os.writeStruct(6, this.tBulletFormat);
    os.writeVector(7, this.vAtSomeone);
    os.writeInt64(8, this.lPid);
    os.writeVector(9, this.vTagInfo);
    os.writeStruct(10, this.tSenceFormat);
};

HUYA.SendMessageReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(0, false, this.tUserId);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(2, false, this.lSid);
    this.sContent= is.readString(3, false, this.sContent);
    this.iShowMode= is.readInt32(4, false, this.iShowMode);
    this.tFormat= is.readStruct(5, false, this.tFormat);
    this.tBulletFormat= is.readStruct(6, false, this.tBulletFormat);
    this.vAtSomeone= is.readVector(7, false, this.vAtSomeone);
    this.lPid= is.readInt64(8, false, this.lPid);
    this.vTagInfo= is.readVector(9, false, this.vTagInfo);
    this.tSenceFormat= is.readStruct(10, false, this.tSenceFormat);
};

HUYA.BadgeInfo = function()
{
    this.lUid = 0;
    this.lBadgeId = 0;
    this.sPresenterNickName = "";
    this.sBadgeName = "";
    this.iBadgeLevel = 0;
    this.iRank = 0;
    this.iScore = 0;
    this.iNextScore = 0;
    this.iQuotaUsed = 0;
    this.iQuota = 0;
    this.lQuotaTS = 0;
    this.lOpenTS = 0;
    this.iVFlag = 0;
    this.sVLogo = "";
    this.tChannelInfo = new HUYA.PresenterChannelInfo();
    this.sPresenterLogo = "";
    this.lVExpiredTS = 0;
    this.iBadgeType = 0;
    this.tFaithInfo = new HUYA.FaithInfo();
    this.tSuperFansInfo = new HUYA.SuperFansInfo();
    this.iBaseQuota = 0;
    this.lVConsumRank = 0;
};
HUYA.BadgeInfo.prototype._clone = function () { return new HUYA.BadgeInfo(); }
HUYA.BadgeInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BadgeInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BadgeInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lBadgeId);
    os.writeString(2, this.sPresenterNickName);
    os.writeString(3, this.sBadgeName);
    os.writeInt32(4, this.iBadgeLevel);
    os.writeInt32(5, this.iRank);
    os.writeInt32(6, this.iScore);
    os.writeInt32(7, this.iNextScore);
    os.writeInt32(8, this.iQuotaUsed);
    os.writeInt32(9, this.iQuota);
    os.writeInt64(10, this.lQuotaTS);
    os.writeInt64(11, this.lOpenTS);
    os.writeInt32(12, this.iVFlag);
    os.writeString(13, this.sVLogo);
    os.writeStruct(14, this.tChannelInfo);
    os.writeString(15, this.sPresenterLogo);
    os.writeInt64(16, this.lVExpiredTS);
    os.writeInt32(17, this.iBadgeType);
    os.writeStruct(18, this.tFaithInfo);
    os.writeStruct(19, this.tSuperFansInfo);
    os.writeInt32(20, this.iBaseQuota);
    os.writeInt64(21, this.lVConsumRank);
};

HUYA.BadgeInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lBadgeId= is.readInt64(1, false, this.lBadgeId);
    this.sPresenterNickName= is.readString(2, false, this.sPresenterNickName);
    this.sBadgeName= is.readString(3, false, this.sBadgeName);
    this.iBadgeLevel= is.readInt32(4, false, this.iBadgeLevel);
    this.iRank= is.readInt32(5, false, this.iRank);
    this.iScore= is.readInt32(6, false, this.iScore);
    this.iNextScore= is.readInt32(7, false, this.iNextScore);
    this.iQuotaUsed= is.readInt32(8, false, this.iQuotaUsed);
    this.iQuota= is.readInt32(9, false, this.iQuota);
    this.lQuotaTS= is.readInt64(10, false, this.lQuotaTS);
    this.lOpenTS= is.readInt64(11, false, this.lOpenTS);
    this.iVFlag= is.readInt32(12, false, this.iVFlag);
    this.sVLogo= is.readString(13, false, this.sVLogo);
    this.tChannelInfo= is.readStruct(14, false, this.tChannelInfo);
    this.sPresenterLogo= is.readString(15, false, this.sPresenterLogo);
    this.lVExpiredTS= is.readInt64(16, false, this.lVExpiredTS);
    this.iBadgeType= is.readInt32(17, false, this.iBadgeType);
    this.tFaithInfo= is.readStruct(18, false, this.tFaithInfo);
    this.tSuperFansInfo= is.readStruct(19, false, this.tSuperFansInfo);
    this.iBaseQuota= is.readInt32(20, false, this.iBaseQuota);
    this.lVConsumRank= is.readInt64(21, false, this.lVConsumRank);
};

HUYA.ActivityTimeEventType = function()
{
    this.iIgnoreIfExists = 0;
    this.iBroadcastTrigger = 0;
    this.iPeriod = 0;
};
HUYA.ActivityTimeEventType.prototype._clone = function () { return new HUYA.ActivityTimeEventType(); }
HUYA.ActivityTimeEventType.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityTimeEventType.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityTimeEventType.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iIgnoreIfExists);
    os.writeInt32(1, this.iBroadcastTrigger);
    os.writeInt32(2, this.iPeriod);
};

HUYA.ActivityTimeEventType.prototype.readFrom = function (is)
{
    this.iIgnoreIfExists= is.readInt32(0, false, this.iIgnoreIfExists);
    this.iBroadcastTrigger= is.readInt32(1, false, this.iBroadcastTrigger);
    this.iPeriod= is.readInt32(2, false, this.iPeriod);
};

HUYA.ActivityTimeEventCBData = function()
{
    this.lTid = 0;
    this.lSid = 0;
    this.sReserved = "";
    this.lHashCode = -1;
};
HUYA.ActivityTimeEventCBData.prototype._clone = function () { return new HUYA.ActivityTimeEventCBData(); }
HUYA.ActivityTimeEventCBData.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityTimeEventCBData.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityTimeEventCBData.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lTid);
    os.writeInt64(1, this.lSid);
    os.writeString(2, this.sReserved);
    os.writeInt64(3, this.lHashCode);
};

HUYA.ActivityTimeEventCBData.prototype.readFrom = function (is)
{
    this.lTid= is.readInt64(0, false, this.lTid);
    this.lSid= is.readInt64(1, false, this.lSid);
    this.sReserved= is.readString(2, false, this.sReserved);
    this.lHashCode= is.readInt64(3, false, this.lHashCode);
};

HUYA.ActivitySerializedMsg = function()
{
    this.iSubUri = 0;
    this.vContent = new Taf.BinBuffer();
};
HUYA.ActivitySerializedMsg.prototype._clone = function () { return new HUYA.ActivitySerializedMsg(); }
HUYA.ActivitySerializedMsg.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivitySerializedMsg.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivitySerializedMsg.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iSubUri);
    os.writeBytes(1, this.vContent);
};

HUYA.ActivitySerializedMsg.prototype.readFrom = function (is)
{
    this.iSubUri= is.readInt32(0, false, this.iSubUri);
    this.vContent= is.readBytes(1, false, this.vContent);
};

HUYA.VipInfoChangedReq = function()
{
    this.iVipType = 0;
    this.lUid = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.lPid = 0;
    this.lLevel = 0;
    this.sSerializeData = "";
};
HUYA.VipInfoChangedReq.prototype._clone = function () { return new HUYA.VipInfoChangedReq(); }
HUYA.VipInfoChangedReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VipInfoChangedReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VipInfoChangedReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iVipType);
    os.writeInt64(1, this.lUid);
    os.writeInt64(2, this.lTid);
    os.writeInt64(3, this.lSid);
    os.writeInt64(4, this.lPid);
    os.writeInt64(5, this.lLevel);
    os.writeString(6, this.sSerializeData);
};

HUYA.VipInfoChangedReq.prototype.readFrom = function (is)
{
    this.iVipType= is.readInt32(0, false, this.iVipType);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.lTid= is.readInt64(2, false, this.lTid);
    this.lSid= is.readInt64(3, false, this.lSid);
    this.lPid= is.readInt64(4, false, this.lPid);
    this.lLevel= is.readInt64(5, false, this.lLevel);
    this.sSerializeData= is.readString(6, false, this.sSerializeData);
};

HUYA.UsingBadgeUpdated = function()
{
    this.lUid = 0;
    this.iOriginalBadgeId = 0;
    this.iBadgeId = 0;
};
HUYA.UsingBadgeUpdated.prototype._clone = function () { return new HUYA.UsingBadgeUpdated(); }
HUYA.UsingBadgeUpdated.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UsingBadgeUpdated.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UsingBadgeUpdated.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.iOriginalBadgeId);
    os.writeInt64(2, this.iBadgeId);
};

HUYA.UsingBadgeUpdated.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.iOriginalBadgeId= is.readInt64(1, false, this.iOriginalBadgeId);
    this.iBadgeId= is.readInt64(2, false, this.iBadgeId);
};

HUYA.UserSessionBeginEvent = function()
{
    this.sSessionId = "";
    this.tId = new HUYA.UserId();
    this.lTopCid = 0;
    this.lSubCid = 0;
    this.lBegintime = 0;
    this.sTraceSource = "";
    this.sClientIp = "";
    this.bAnonymous = true;
    this.lPid = 0;
};
HUYA.UserSessionBeginEvent.prototype._clone = function () { return new HUYA.UserSessionBeginEvent(); }
HUYA.UserSessionBeginEvent.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserSessionBeginEvent.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserSessionBeginEvent.prototype.writeTo = function (os)
{
    os.writeString(0, this.sSessionId);
    os.writeStruct(1, this.tId);
    os.writeInt64(2, this.lTopCid);
    os.writeInt64(3, this.lSubCid);
    os.writeInt64(4, this.lBegintime);
    os.writeString(5, this.sTraceSource);
    os.writeString(6, this.sClientIp);
    os.writeBoolean(7, this.bAnonymous);
    os.writeInt64(8, this.lPid);
};

HUYA.UserSessionBeginEvent.prototype.readFrom = function (is)
{
    this.sSessionId= is.readString(0, false, this.sSessionId);
    this.tId= is.readStruct(1, false, this.tId);
    this.lTopCid= is.readInt64(2, false, this.lTopCid);
    this.lSubCid= is.readInt64(3, false, this.lSubCid);
    this.lBegintime= is.readInt64(4, false, this.lBegintime);
    this.sTraceSource= is.readString(5, false, this.sTraceSource);
    this.sClientIp= is.readString(6, false, this.sClientIp);
    this.bAnonymous= is.readBoolean(7, false, this.bAnonymous);
    this.lPid= is.readInt64(8, false, this.lPid);
};

HUYA.SendItemEdgeEventReq = function()
{
    this.tId = new HUYA.UserId();
    this.lSid = 0;
    this.lSubSid = 0;
    this.iItemType = 0;
    this.iItemCount = 0;
    this.lPresenterUid = 0;
    this.sPayId = "";
    this.sSenderNick = "";
    this.sPresenterNick = "";
    this.iItemCountByGroup = 0;
    this.iItemGroup = 0;
    this.iSuperPupleLevel = 0;
    this.iFromType = 0;
    this.iPayType = 0;
    this.iTemplateType = 0;
    this.iTotalPay = 0;
    this.sExpand = "";
    this.iIsGroup = 0;
    this.bWorldBanner = true;
    this.iEffectType = 0;
    this.iColorEffectType = 0;
    this.iWeekStart = 0;
    this.lPayTime = 0;
    this.lGameId = 0;
    this.iItemEventType = 0;
    this.sItemEventContent = "";
    this.sSenderIcon = "";
    this.sPresenterIcon = "";
    this.lRoomId = 0;
    this.lHomeOwnerUid = 0;
    this.lLiveId = 0;
    this.lMicUid = 0;
};
HUYA.SendItemEdgeEventReq.prototype._clone = function () { return new HUYA.SendItemEdgeEventReq(); }
HUYA.SendItemEdgeEventReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SendItemEdgeEventReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SendItemEdgeEventReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lSid);
    os.writeInt64(2, this.lSubSid);
    os.writeInt32(3, this.iItemType);
    os.writeInt32(4, this.iItemCount);
    os.writeInt64(5, this.lPresenterUid);
    os.writeString(6, this.sPayId);
    os.writeString(7, this.sSenderNick);
    os.writeString(8, this.sPresenterNick);
    os.writeInt32(9, this.iItemCountByGroup);
    os.writeInt32(10, this.iItemGroup);
    os.writeInt32(11, this.iSuperPupleLevel);
    os.writeInt32(12, this.iFromType);
    os.writeInt32(13, this.iPayType);
    os.writeInt32(14, this.iTemplateType);
    os.writeInt32(15, this.iTotalPay);
    os.writeString(16, this.sExpand);
    os.writeInt16(17, this.iIsGroup);
    os.writeBoolean(18, this.bWorldBanner);
    os.writeInt32(19, this.iEffectType);
    os.writeInt32(20, this.iColorEffectType);
    os.writeInt16(21, this.iWeekStart);
    os.writeInt64(22, this.lPayTime);
    os.writeInt64(23, this.lGameId);
    os.writeInt16(24, this.iItemEventType);
    os.writeString(25, this.sItemEventContent);
    os.writeString(26, this.sSenderIcon);
    os.writeString(27, this.sPresenterIcon);
    os.writeInt64(28, this.lRoomId);
    os.writeInt64(29, this.lHomeOwnerUid);
    os.writeInt64(30, this.lLiveId);
    os.writeInt64(31, this.lMicUid);
};

HUYA.SendItemEdgeEventReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lSid= is.readInt64(1, false, this.lSid);
    this.lSubSid= is.readInt64(2, false, this.lSubSid);
    this.iItemType= is.readInt32(3, false, this.iItemType);
    this.iItemCount= is.readInt32(4, false, this.iItemCount);
    this.lPresenterUid= is.readInt64(5, false, this.lPresenterUid);
    this.sPayId= is.readString(6, false, this.sPayId);
    this.sSenderNick= is.readString(7, false, this.sSenderNick);
    this.sPresenterNick= is.readString(8, false, this.sPresenterNick);
    this.iItemCountByGroup= is.readInt32(9, false, this.iItemCountByGroup);
    this.iItemGroup= is.readInt32(10, false, this.iItemGroup);
    this.iSuperPupleLevel= is.readInt32(11, false, this.iSuperPupleLevel);
    this.iFromType= is.readInt32(12, false, this.iFromType);
    this.iPayType= is.readInt32(13, false, this.iPayType);
    this.iTemplateType= is.readInt32(14, false, this.iTemplateType);
    this.iTotalPay= is.readInt32(15, false, this.iTotalPay);
    this.sExpand= is.readString(16, false, this.sExpand);
    this.iIsGroup= is.readInt16(17, false, this.iIsGroup);
    this.bWorldBanner= is.readBoolean(18, false, this.bWorldBanner);
    this.iEffectType= is.readInt32(19, false, this.iEffectType);
    this.iColorEffectType= is.readInt32(20, false, this.iColorEffectType);
    this.iWeekStart= is.readInt16(21, false, this.iWeekStart);
    this.lPayTime= is.readInt64(22, false, this.lPayTime);
    this.lGameId= is.readInt64(23, false, this.lGameId);
    this.iItemEventType= is.readInt16(24, false, this.iItemEventType);
    this.sItemEventContent= is.readString(25, false, this.sItemEventContent);
    this.sSenderIcon= is.readString(26, false, this.sSenderIcon);
    this.sPresenterIcon= is.readString(27, false, this.sPresenterIcon);
    this.lRoomId= is.readInt64(28, false, this.lRoomId);
    this.lHomeOwnerUid= is.readInt64(29, false, this.lHomeOwnerUid);
    this.lLiveId= is.readInt64(30, false, this.lLiveId);
    this.lMicUid= is.readInt64(31, false, this.lMicUid);
};

HUYA.PushNewGuardianReq = function()
{
    this.tId = new HUYA.UserId();
    this.lUid = 0;
    this.sNick = "";
    this.iLevel = 0;
    this.lStartTime = 0;
    this.lEndTime = 0;
    this.lGuardianUid = 0;
    this.sGuardianNick = "";
    this.iOpenDays = 0;
    this.iLastLevel = 0;
};
HUYA.PushNewGuardianReq.prototype._clone = function () { return new HUYA.PushNewGuardianReq(); }
HUYA.PushNewGuardianReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PushNewGuardianReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PushNewGuardianReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lUid);
    os.writeString(2, this.sNick);
    os.writeInt32(3, this.iLevel);
    os.writeInt64(4, this.lStartTime);
    os.writeInt64(5, this.lEndTime);
    os.writeInt64(6, this.lGuardianUid);
    os.writeString(7, this.sGuardianNick);
    os.writeInt32(8, this.iOpenDays);
    os.writeInt32(9, this.iLastLevel);
};

HUYA.PushNewGuardianReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.sNick= is.readString(2, false, this.sNick);
    this.iLevel= is.readInt32(3, false, this.iLevel);
    this.lStartTime= is.readInt64(4, false, this.lStartTime);
    this.lEndTime= is.readInt64(5, false, this.lEndTime);
    this.lGuardianUid= is.readInt64(6, false, this.lGuardianUid);
    this.sGuardianNick= is.readString(7, false, this.sGuardianNick);
    this.iOpenDays= is.readInt32(8, false, this.iOpenDays);
    this.iLastLevel= is.readInt32(9, false, this.iLastLevel);
};

HUYA.PresenterHeartbeatEvent = function()
{
    this.tGameLiveInfo = new HUYA.GameLiveInfo();
    this.tGameLiveMisc = new HUYA.GameLiveMisc();
    this.mReportMessage = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};
HUYA.PresenterHeartbeatEvent.prototype._clone = function () { return new HUYA.PresenterHeartbeatEvent(); }
HUYA.PresenterHeartbeatEvent.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterHeartbeatEvent.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterHeartbeatEvent.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tGameLiveInfo);
    os.writeStruct(1, this.tGameLiveMisc);
    os.writeMap(2, this.mReportMessage);
};

HUYA.PresenterHeartbeatEvent.prototype.readFrom = function (is)
{
    this.tGameLiveInfo= is.readStruct(0, false, this.tGameLiveInfo);
    this.tGameLiveMisc= is.readStruct(1, false, this.tGameLiveMisc);
    this.mReportMessage= is.readMap(2, false, this.mReportMessage);
};

HUYA.NobleLevelChangedReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.tNoble = new HUYA.NobleInfo();
    this.iOpType = 0;
    this.iType = 0;
    this.lOldValidDate = 0;
    this.tOldLevel = new HUYA.NobleLevelInfo();
};
HUYA.NobleLevelChangedReq.prototype._clone = function () { return new HUYA.NobleLevelChangedReq(); }
HUYA.NobleLevelChangedReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.NobleLevelChangedReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.NobleLevelChangedReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserId);
    os.writeStruct(1, this.tNoble);
    os.writeInt32(2, this.iOpType);
    os.writeInt32(3, this.iType);
    os.writeInt64(4, this.lOldValidDate);
    os.writeStruct(5, this.tOldLevel);
};

HUYA.NobleLevelChangedReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(0, false, this.tUserId);
    this.tNoble= is.readStruct(1, false, this.tNoble);
    this.iOpType= is.readInt32(2, false, this.iOpType);
    this.iType= is.readInt32(3, false, this.iType);
    this.lOldValidDate= is.readInt64(4, false, this.lOldValidDate);
    this.tOldLevel= is.readStruct(5, false, this.tOldLevel);
};

HUYA.LiveShareEventReq = function()
{
    this.tId = new HUYA.UserId();
    this.sTitle = "";
    this.sSubTitle = "";
    this.sContent = "";
    this.sAction = "";
    this.lPresenterUid = 0;
    this.iPlatform = 0;
    this.sImageUrl = "";
    this.lYYId = 0;
    this.lLiveId = 0;
    this.iShareType = 0;
};
HUYA.LiveShareEventReq.prototype._clone = function () { return new HUYA.LiveShareEventReq(); }
HUYA.LiveShareEventReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveShareEventReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.LiveShareEventReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeString(1, this.sTitle);
    os.writeString(2, this.sSubTitle);
    os.writeString(3, this.sContent);
    os.writeString(4, this.sAction);
    os.writeInt64(5, this.lPresenterUid);
    os.writeInt32(6, this.iPlatform);
    os.writeString(7, this.sImageUrl);
    os.writeInt64(8, this.lYYId);
    os.writeInt64(9, this.lLiveId);
    os.writeInt32(10, this.iShareType);
};

HUYA.LiveShareEventReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.sTitle= is.readString(1, false, this.sTitle);
    this.sSubTitle= is.readString(2, false, this.sSubTitle);
    this.sContent= is.readString(3, false, this.sContent);
    this.sAction= is.readString(4, false, this.sAction);
    this.lPresenterUid= is.readInt64(5, false, this.lPresenterUid);
    this.iPlatform= is.readInt32(6, false, this.iPlatform);
    this.sImageUrl= is.readString(7, false, this.sImageUrl);
    this.lYYId= is.readInt64(8, false, this.lYYId);
    this.lLiveId= is.readInt64(9, false, this.lLiveId);
    this.iShareType= is.readInt32(10, false, this.iShareType);
};

HUYA.H5ExternalFilterRsp = function()
{
    this.iRetCode = 0;
};
HUYA.H5ExternalFilterRsp.prototype._clone = function () { return new HUYA.H5ExternalFilterRsp(); }
HUYA.H5ExternalFilterRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.H5ExternalFilterRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.H5ExternalFilterRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRetCode);
};

HUYA.H5ExternalFilterRsp.prototype.readFrom = function (is)
{
    this.iRetCode= is.readInt32(0, false, this.iRetCode);
};

HUYA.H5ExternalFilterReq = function()
{
    this.tId = new HUYA.UserId();
    this.lPid = 0;
    this.iGameId = 0;
    this.iActId = 0;
    this.lHideURI = 0;
};
HUYA.H5ExternalFilterReq.prototype._clone = function () { return new HUYA.H5ExternalFilterReq(); }
HUYA.H5ExternalFilterReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.H5ExternalFilterReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.H5ExternalFilterReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lPid);
    os.writeInt32(2, this.iGameId);
    os.writeInt32(3, this.iActId);
    os.writeInt64(4, this.lHideURI);
};

HUYA.H5ExternalFilterReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lPid= is.readInt64(1, false, this.lPid);
    this.iGameId= is.readInt32(2, false, this.iGameId);
    this.iActId= is.readInt32(3, false, this.iActId);
    this.lHideURI= is.readInt64(4, false, this.lHideURI);
};

HUYA.ExtendSuperFansEvent = function()
{
    this.lUid = 0;
    this.lPid = 0;
    this.lSFExpiredTS = 0;
    this.lSFYearFlagExpiredTS = -1;
    this.iPayValidMonth = 0;
    this.iFreeValidMonth = 0;
    this.iOpType = 0;
    this.sOrderID = "";
    this.iBusinessType = 0;
};
HUYA.ExtendSuperFansEvent.prototype._clone = function () { return new HUYA.ExtendSuperFansEvent(); }
HUYA.ExtendSuperFansEvent.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ExtendSuperFansEvent.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ExtendSuperFansEvent.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lPid);
    os.writeInt64(2, this.lSFExpiredTS);
    os.writeInt64(3, this.lSFYearFlagExpiredTS);
    os.writeInt32(4, this.iPayValidMonth);
    os.writeInt32(5, this.iFreeValidMonth);
    os.writeInt32(6, this.iOpType);
    os.writeString(7, this.sOrderID);
    os.writeInt32(8, this.iBusinessType);
};

HUYA.ExtendSuperFansEvent.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lPid= is.readInt64(1, false, this.lPid);
    this.lSFExpiredTS= is.readInt64(2, false, this.lSFExpiredTS);
    this.lSFYearFlagExpiredTS= is.readInt64(3, false, this.lSFYearFlagExpiredTS);
    this.iPayValidMonth= is.readInt32(4, false, this.iPayValidMonth);
    this.iFreeValidMonth= is.readInt32(5, false, this.iFreeValidMonth);
    this.iOpType= is.readInt32(6, false, this.iOpType);
    this.sOrderID= is.readString(7, false, this.sOrderID);
    this.iBusinessType= is.readInt32(8, false, this.iBusinessType);
};

HUYA.EndLiveEventNotifyReq = function()
{
    this.tGameLiveInfo = new HUYA.GameLiveInfo();
    this.iReason = 0;
    this.tGameLiveMisc = new HUYA.GameLiveMisc();
};
HUYA.EndLiveEventNotifyReq.prototype._clone = function () { return new HUYA.EndLiveEventNotifyReq(); }
HUYA.EndLiveEventNotifyReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.EndLiveEventNotifyReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.EndLiveEventNotifyReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tGameLiveInfo);
    os.writeInt32(1, this.iReason);
    os.writeStruct(2, this.tGameLiveMisc);
};

HUYA.EndLiveEventNotifyReq.prototype.readFrom = function (is)
{
    this.tGameLiveInfo= is.readStruct(0, false, this.tGameLiveInfo);
    this.iReason= is.readInt32(1, false, this.iReason);
    this.tGameLiveMisc= is.readStruct(2, false, this.tGameLiveMisc);
};

HUYA.DecorationInfoRsp = function()
{
    this.vDecorationPrefix = new Taf.Vector(new HUYA.DecorationInfo());
    this.vDecorationSuffix = new Taf.Vector(new HUYA.DecorationInfo());
    this.tFormat = new HUYA.ContentFormat();
    this.tBulletFormat = new HUYA.BulletFormat();
    this.vForwardChannels = new Taf.Vector(new HUYA.ChannelPair());
    this.iModifyMask = 0;
    this.vBulletPrefix = new Taf.Vector(new HUYA.DecorationInfo());
    this.tUserInfo = new HUYA.SenderInfo();
    this.vBulletSuffix = new Taf.Vector(new HUYA.DecorationInfo());
};
HUYA.DecorationInfoRsp.prototype._clone = function () { return new HUYA.DecorationInfoRsp(); }
HUYA.DecorationInfoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.DecorationInfoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.DecorationInfoRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vDecorationPrefix);
    os.writeVector(1, this.vDecorationSuffix);
    os.writeStruct(2, this.tFormat);
    os.writeStruct(3, this.tBulletFormat);
    os.writeVector(4, this.vForwardChannels);
    os.writeInt32(5, this.iModifyMask);
    os.writeVector(6, this.vBulletPrefix);
    os.writeStruct(7, this.tUserInfo);
    os.writeVector(8, this.vBulletSuffix);
};

HUYA.DecorationInfoRsp.prototype.readFrom = function (is)
{
    this.vDecorationPrefix= is.readVector(0, false, this.vDecorationPrefix);
    this.vDecorationSuffix= is.readVector(1, false, this.vDecorationSuffix);
    this.tFormat= is.readStruct(2, false, this.tFormat);
    this.tBulletFormat= is.readStruct(3, false, this.tBulletFormat);
    this.vForwardChannels= is.readVector(4, false, this.vForwardChannels);
    this.iModifyMask= is.readInt32(5, false, this.iModifyMask);
    this.vBulletPrefix= is.readVector(6, false, this.vBulletPrefix);
    this.tUserInfo= is.readStruct(7, false, this.tUserInfo);
    this.vBulletSuffix= is.readVector(8, false, this.vBulletSuffix);
};

HUYA.DecorationInfoReq = function()
{
    this.tSendMsgReq = new HUYA.SendMessageReq();
};
HUYA.DecorationInfoReq.prototype._clone = function () { return new HUYA.DecorationInfoReq(); }
HUYA.DecorationInfoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.DecorationInfoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.DecorationInfoReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tSendMsgReq);
};

HUYA.DecorationInfoReq.prototype.readFrom = function (is)
{
    this.tSendMsgReq= is.readStruct(0, false, this.tSendMsgReq);
};

HUYA.BeginLiveEventNotifyReq = function()
{
    this.tGameLiveInfo = new HUYA.GameLiveInfo();
    this.tGameLiveMisc = new HUYA.GameLiveMisc();
};
HUYA.BeginLiveEventNotifyReq.prototype._clone = function () { return new HUYA.BeginLiveEventNotifyReq(); }
HUYA.BeginLiveEventNotifyReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BeginLiveEventNotifyReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BeginLiveEventNotifyReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tGameLiveInfo);
    os.writeStruct(1, this.tGameLiveMisc);
};

HUYA.BeginLiveEventNotifyReq.prototype.readFrom = function (is)
{
    this.tGameLiveInfo= is.readStruct(0, false, this.tGameLiveInfo);
    this.tGameLiveMisc= is.readStruct(1, false, this.tGameLiveMisc);
};

HUYA.BadgeUpdated = function()
{
    this.lUid = 0;
    this.lBadgeId = 0;
    this.tOriginalInfo = new HUYA.BadgeInfo();
    this.tInfo = new HUYA.BadgeInfo();
    this.iItemType = 0;
};
HUYA.BadgeUpdated.prototype._clone = function () { return new HUYA.BadgeUpdated(); }
HUYA.BadgeUpdated.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BadgeUpdated.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BadgeUpdated.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lBadgeId);
    os.writeStruct(2, this.tOriginalInfo);
    os.writeStruct(3, this.tInfo);
    os.writeInt32(4, this.iItemType);
};

HUYA.BadgeUpdated.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lBadgeId= is.readInt64(1, false, this.lBadgeId);
    this.tOriginalInfo= is.readStruct(2, false, this.tOriginalInfo);
    this.tInfo= is.readStruct(3, false, this.tInfo);
    this.iItemType= is.readInt32(4, false, this.iItemType);
};

HUYA.ActivityTimeEvent = function()
{
    this.iActivityId = 0;
    this.lUid = 0;
    this.iEventId = 0;
    this.iTriggerDelay = 0;
    this.tType = new HUYA.ActivityTimeEventType();
    this.tCallBackData = new HUYA.ActivityTimeEventCBData();
};
HUYA.ActivityTimeEvent.prototype._clone = function () { return new HUYA.ActivityTimeEvent(); }
HUYA.ActivityTimeEvent.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityTimeEvent.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityTimeEvent.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iActivityId);
    os.writeInt64(1, this.lUid);
    os.writeInt32(2, this.iEventId);
    os.writeInt32(3, this.iTriggerDelay);
    os.writeStruct(4, this.tType);
    os.writeStruct(5, this.tCallBackData);
};

HUYA.ActivityTimeEvent.prototype.readFrom = function (is)
{
    this.iActivityId= is.readInt32(0, false, this.iActivityId);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.iEventId= is.readInt32(2, false, this.iEventId);
    this.iTriggerDelay= is.readInt32(3, false, this.iTriggerDelay);
    this.tType= is.readStruct(4, false, this.tType);
    this.tCallBackData= is.readStruct(5, false, this.tCallBackData);
};

HUYA.ActivityMsgRsp = function()
{
    this.iEnable = 0;
    this.vSerializedMsg = new Taf.Vector(new HUYA.ActivitySerializedMsg());
    this.iTimeStamp = 0;
};
HUYA.ActivityMsgRsp.prototype._clone = function () { return new HUYA.ActivityMsgRsp(); }
HUYA.ActivityMsgRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityMsgRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityMsgRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iEnable);
    os.writeVector(1, this.vSerializedMsg);
    os.writeInt32(2, this.iTimeStamp);
};

HUYA.ActivityMsgRsp.prototype.readFrom = function (is)
{
    this.iEnable= is.readInt32(0, false, this.iEnable);
    this.vSerializedMsg= is.readVector(1, false, this.vSerializedMsg);
    this.iTimeStamp= is.readInt32(2, false, this.iTimeStamp);
};

HUYA.ActivityMsgReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.iActivityId = 0;
    this.lPid = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.iChannelType = 0;
    this.iSubUri = 0;
};
HUYA.ActivityMsgReq.prototype._clone = function () { return new HUYA.ActivityMsgReq(); }
HUYA.ActivityMsgReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityMsgReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityMsgReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserId);
    os.writeInt32(1, this.iActivityId);
    os.writeInt64(2, this.lPid);
    os.writeInt64(3, this.lTid);
    os.writeInt64(4, this.lSid);
    os.writeInt32(5, this.iChannelType);
    os.writeInt32(6, this.iSubUri);
};

HUYA.ActivityMsgReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(0, false, this.tUserId);
    this.iActivityId= is.readInt32(1, false, this.iActivityId);
    this.lPid= is.readInt64(2, false, this.lPid);
    this.lTid= is.readInt64(3, false, this.lTid);
    this.lSid= is.readInt64(4, false, this.lSid);
    this.iChannelType= is.readInt32(5, false, this.iChannelType);
    this.iSubUri= is.readInt32(6, false, this.iSubUri);
};

var ActPK = ActPK || {};


ActPK.ActPKUpdateInfo = function()
{
    this.lUid = 0;
    this.lPid = 0;
    this.iItemType = 0;
    this.iItemCount = 0;
    this.lScore = 0;
    this.bIsOrder = false;
    this.iBroadcast = 0;
    this.lMicUid = 0;
};
ActPK.ActPKUpdateInfo.prototype._clone = function () { return new ActPK.ActPKUpdateInfo(); }
ActPK.ActPKUpdateInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActPK.ActPKUpdateInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActPK.ActPKUpdateInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lPid);
    os.writeInt32(2, this.iItemType);
    os.writeInt32(3, this.iItemCount);
    os.writeInt64(4, this.lScore);
    os.writeBoolean(5, this.bIsOrder);
    os.writeInt32(6, this.iBroadcast);
    os.writeInt64(7, this.lMicUid);
};

ActPK.ActPKUpdateInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lPid= is.readInt64(1, false, this.lPid);
    this.iItemType= is.readInt32(2, false, this.iItemType);
    this.iItemCount= is.readInt32(3, false, this.iItemCount);
    this.lScore= is.readInt64(4, false, this.lScore);
    this.bIsOrder= is.readBoolean(5, false, this.bIsOrder);
    this.iBroadcast= is.readInt32(6, false, this.iBroadcast);
    this.lMicUid= is.readInt64(7, false, this.lMicUid);
};


ActPK.ActPKInfo = function()
{
    this.lActId = 0;
    this.lPKId = 0;
    this.iType = 0;
    this.iArea = 0;
    this.lAttPid = 0;
    this.lAttScore = 0;
    this.lDefPid = 0;
    this.lDefScore = 0;
    this.iBeginTime = 0;
    this.iEndTime = 0;
    this.iKillTime = 0;
    this.iState = 0;
    this.lAttReward = 0;
    this.lDefReward = 0;
    this.lFlag = 0;
    this.lFlag2 = 0;
    this.lGameId = 0;
    this.lAttPKBuff = 0;
    this.lDefPKBuff = 0;
    this.sUserCustom = "";
    this.iLeftCDTime = 0;
    this.iLeftGuardTime = 0;
};
ActPK.ActPKInfo.prototype._clone = function () { return new ActPK.ActPKInfo(); }
ActPK.ActPKInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActPK.ActPKInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActPK.ActPKInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lActId);
    os.writeInt64(1, this.lPKId);
    os.writeInt32(2, this.iType);
    os.writeInt32(3, this.iArea);
    os.writeInt64(4, this.lAttPid);
    os.writeInt64(5, this.lAttScore);
    os.writeInt64(6, this.lDefPid);
    os.writeInt64(7, this.lDefScore);
    os.writeInt32(8, this.iBeginTime);
    os.writeInt32(9, this.iEndTime);
    os.writeInt32(10, this.iKillTime);
    os.writeInt32(11, this.iState);
    os.writeInt64(12, this.lAttReward);
    os.writeInt64(13, this.lDefReward);
    os.writeInt64(14, this.lFlag);
    os.writeInt64(15, this.lFlag2);
    os.writeInt64(16, this.lGameId);
    os.writeInt64(17, this.lAttPKBuff);
    os.writeInt64(18, this.lDefPKBuff);
    os.writeString(19, this.sUserCustom);
    os.writeInt32(20, this.iLeftCDTime);
    os.writeInt32(21, this.iLeftGuardTime);
};

ActPK.ActPKInfo.prototype.readFrom = function (is)
{
    this.lActId= is.readInt64(0, false, this.lActId);
    this.lPKId= is.readInt64(1, false, this.lPKId);
    this.iType= is.readInt32(2, false, this.iType);
    this.iArea= is.readInt32(3, false, this.iArea);
    this.lAttPid= is.readInt64(4, false, this.lAttPid);
    this.lAttScore= is.readInt64(5, false, this.lAttScore);
    this.lDefPid= is.readInt64(6, false, this.lDefPid);
    this.lDefScore= is.readInt64(7, false, this.lDefScore);
    this.iBeginTime= is.readInt32(8, false, this.iBeginTime);
    this.iEndTime= is.readInt32(9, false, this.iEndTime);
    this.iKillTime= is.readInt32(10, false, this.iKillTime);
    this.iState= is.readInt32(11, false, this.iState);
    this.lAttReward= is.readInt64(12, false, this.lAttReward);
    this.lDefReward= is.readInt64(13, false, this.lDefReward);
    this.lFlag= is.readInt64(14, false, this.lFlag);
    this.lFlag2= is.readInt64(15, false, this.lFlag2);
    this.lGameId= is.readInt64(16, false, this.lGameId);
    this.lAttPKBuff= is.readInt64(17, false, this.lAttPKBuff);
    this.lDefPKBuff= is.readInt64(18, false, this.lDefPKBuff);
    this.sUserCustom= is.readString(19, false, this.sUserCustom);
    this.iLeftCDTime= is.readInt32(20, false, this.iLeftCDTime);
    this.iLeftGuardTime= is.readInt32(21, false, this.iLeftGuardTime);
};

var ActDocor = ActDocor || {};


ActDocor.GmMessageReq = function()
{
    this.iCmdId = 0;
    this.lUid = 0;
    this.lPid = 0;
    this.sContent = "";
};
ActDocor.GmMessageReq.prototype._clone = function () { return new ActDocor.GmMessageReq(); }
ActDocor.GmMessageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActDocor.GmMessageReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActDocor.GmMessageReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iCmdId);
    os.writeInt64(1, this.lUid);
    os.writeInt64(2, this.lPid);
    os.writeString(3, this.sContent);
};

ActDocor.GmMessageReq.prototype.readFrom = function (is)
{
    this.iCmdId= is.readInt32(0, false, this.iCmdId);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.lPid= is.readInt64(2, false, this.lPid);
    this.sContent= is.readString(3, false, this.sContent);
};

var Act2021Driver = Act2021Driver || {};


Act2021Driver.TemplateURI = 
{
    PushAnchorPanel: 20210101,
    PushUpdateScorePanel: 20210102,
    PushCarPanel: 20210103,
    PushAreaRankPanel: 20210104,
    PushDayRankPanel: 20210105,
    PushHourRankPanel: 20210106,
    PushPromoteResultPanel: 20210107,
    PushHonorResultPanel: 20210108,
    PushBattleUpdatePanel: 20210109,
    PushBattlePanel: 20210110,
    PushBattleAnnouncePanel: 20210111,
    PushBattleResultPanel: 20210112,
    PushBattleFansScore: 20210113,
    PushActivePkPanel: 20210114,
    PushTaskUpdate: 20210131,
    PushTaskItemUpdate: 20210132,
    PushLotteryInfoPanel: 20210133,
    PushLotteryRecordPanel: 20210134,
    PushClearPanel: 20210199
};

Act2021Driver.STAGE = 
{
    kBeforeActivityStage: 0,
    kMatchStage: 1,
    kHonorStage: 2
};

Act2021Driver.E_CAR_COLOR = 
{
    CAR_COLOR_NONE: 0,
    CAR_COLOR_RED: 1,
    CAR_COLOR_GREEN: 2,
    CAR_COLOR_BLUE: 3,
    CAR_COLOR_PURPLE: 4,
    CAR_COLOR_BLACK: 5,
    CAR_COLOR_YELLOW: 6,
    CAR_COLOR_GOLDEN: 7,
    CAR_COLOR_ORANGE: 8
};

Act2021Driver.CType = 
{
    E_CType_Content: 1,
    E_CType_Pic: 2
};

Act2021Driver.TaskLevel = 
{
    E_TaskLevel_A: 1,
    E_TaskLevel_S: 2,
    E_TaskLevel_SS: 3
};

Act2021Driver.TaskState = 
{
    E_TaskState_Doing: 0,
    E_TaskState_Done: 1
};

Act2021Driver.TaskId = 
{
    E_TaskId_PK: 1000,
    E_TaskId_ACCEL: 1001,
    E_TaskId_CAR: 1002,
    E_TaskId_SUPER_CAR: 1003,
    E_TaskId_ACCEL_RECV: 1004
};

Act2021Driver.BONUS_TYPE = 
{
    E_BONUS_DRIVE_SCORE: 1,
    E_BONUS_POPULAR_SCORE: 2,
    E_BONUS_PKBUFF: 3,
    E_BONUS_SUPER_FANS: 4,
    E_BONUS_DIAMOND_FANS: 5,
    E_BONUS_DIY_CAR: 6
};

Act2021Driver.JumpChannel = function()
{
    this.lPid = 0;
    this.iGameId = 0;
    this.iRoomId = 0;
    this.iIsLive = 0;
};
Act2021Driver.JumpChannel.prototype._clone = function () { return new Act2021Driver.JumpChannel(); }
Act2021Driver.JumpChannel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.JumpChannel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.JumpChannel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iGameId);
    os.writeInt32(2, this.iRoomId);
    os.writeInt32(3, this.iIsLive);
};

Act2021Driver.JumpChannel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iGameId= is.readInt32(1, false, this.iGameId);
    this.iRoomId= is.readInt32(2, false, this.iRoomId);
    this.iIsLive= is.readInt32(3, false, this.iIsLive);
};

Act2021Driver.RankItem = function()
{
    this.tJump = new Act2021Driver.JumpChannel();
    this.iRank = 0;
    this.lScore = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
};
Act2021Driver.RankItem.prototype._clone = function () { return new Act2021Driver.RankItem(); }
Act2021Driver.RankItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.RankItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.RankItem.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tJump);
    os.writeInt32(1, this.iRank);
    os.writeInt64(2, this.lScore);
    os.writeString(3, this.sNickName);
    os.writeString(4, this.sLogoUrl);
};

Act2021Driver.RankItem.prototype.readFrom = function (is)
{
    this.tJump= is.readStruct(0, false, this.tJump);
    this.iRank= is.readInt32(1, false, this.iRank);
    this.lScore= is.readInt64(2, false, this.lScore);
    this.sNickName= is.readString(3, false, this.sNickName);
    this.sLogoUrl= is.readString(4, false, this.sLogoUrl);
};

Act2021Driver.AnchorUpdate = function()
{
    this.lPid = 0;
    this.iDayRank = 0;
    this.lDayScore = 0;
    this.iHour = 0;
    this.iHourRank = 0;
    this.lHourScore = 0;
    this.iBuffRate = 0;
    this.iBuffMin = 0;
    this.iTotalRank = 0;
    this.lTotalScore = 0;
};
Act2021Driver.AnchorUpdate.prototype._clone = function () { return new Act2021Driver.AnchorUpdate(); }
Act2021Driver.AnchorUpdate.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.AnchorUpdate.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.AnchorUpdate.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iDayRank);
    os.writeInt64(2, this.lDayScore);
    os.writeInt32(3, this.iHour);
    os.writeInt32(4, this.iHourRank);
    os.writeInt64(5, this.lHourScore);
    os.writeInt32(6, this.iBuffRate);
    os.writeInt32(7, this.iBuffMin);
    os.writeInt32(8, this.iTotalRank);
    os.writeInt64(9, this.lTotalScore);
};

Act2021Driver.AnchorUpdate.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iDayRank= is.readInt32(1, false, this.iDayRank);
    this.lDayScore= is.readInt64(2, false, this.lDayScore);
    this.iHour= is.readInt32(3, false, this.iHour);
    this.iHourRank= is.readInt32(4, false, this.iHourRank);
    this.lHourScore= is.readInt64(5, false, this.lHourScore);
    this.iBuffRate= is.readInt32(6, false, this.iBuffRate);
    this.iBuffMin= is.readInt32(7, false, this.iBuffMin);
    this.iTotalRank= is.readInt32(8, false, this.iTotalRank);
    this.lTotalScore= is.readInt64(9, false, this.lTotalScore);
};

Act2021Driver.AnchorPanel = function()
{
    this.sLogoUrl = "";
    this.iAreaId = 0;
    this.sAreaName = "";
    this.iCurrentDay = 0;
    this.iMaxDay = 0;
    this.tUpdate = new Act2021Driver.AnchorUpdate();
    this.sNickName = "";
};
Act2021Driver.AnchorPanel.prototype._clone = function () { return new Act2021Driver.AnchorPanel(); }
Act2021Driver.AnchorPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.AnchorPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.AnchorPanel.prototype.writeTo = function (os)
{
    os.writeString(0, this.sLogoUrl);
    os.writeInt32(1, this.iAreaId);
    os.writeString(2, this.sAreaName);
    os.writeInt32(3, this.iCurrentDay);
    os.writeInt32(4, this.iMaxDay);
    os.writeStruct(5, this.tUpdate);
    os.writeString(6, this.sNickName);
};

Act2021Driver.AnchorPanel.prototype.readFrom = function (is)
{
    this.sLogoUrl= is.readString(0, false, this.sLogoUrl);
    this.iAreaId= is.readInt32(1, false, this.iAreaId);
    this.sAreaName= is.readString(2, false, this.sAreaName);
    this.iCurrentDay= is.readInt32(3, false, this.iCurrentDay);
    this.iMaxDay= is.readInt32(4, false, this.iMaxDay);
    this.tUpdate= is.readStruct(5, false, this.tUpdate);
    this.sNickName= is.readString(6, false, this.sNickName);
};

Act2021Driver.CarPanel = function()
{
    this.lPid = 0;
    this.sNickName = "";
    this.iCarColorId = 0;
    this.sCarLogoUrl = "";
    this.iTotalFans = 0;
    this.sTeamName = "";
    this.vCarUrlList = new Taf.Vector(new Taf.STRING());
    this.iEnableDiy = 0;
};
Act2021Driver.CarPanel.prototype._clone = function () { return new Act2021Driver.CarPanel(); }
Act2021Driver.CarPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.CarPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.CarPanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeString(1, this.sNickName);
    os.writeInt32(2, this.iCarColorId);
    os.writeString(3, this.sCarLogoUrl);
    os.writeInt32(4, this.iTotalFans);
    os.writeString(5, this.sTeamName);
    os.writeVector(6, this.vCarUrlList);
    os.writeInt32(7, this.iEnableDiy);
};

Act2021Driver.CarPanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.iCarColorId= is.readInt32(2, false, this.iCarColorId);
    this.sCarLogoUrl= is.readString(3, false, this.sCarLogoUrl);
    this.iTotalFans= is.readInt32(4, false, this.iTotalFans);
    this.sTeamName= is.readString(5, false, this.sTeamName);
    this.vCarUrlList= is.readVector(6, false, this.vCarUrlList);
    this.iEnableDiy= is.readInt32(7, false, this.iEnableDiy);
};

Act2021Driver.AreaRankPanel = function()
{
    this.iAreaId = 0;
    this.vRankList = new Taf.Vector(new Act2021Driver.RankItem());
};
Act2021Driver.AreaRankPanel.prototype._clone = function () { return new Act2021Driver.AreaRankPanel(); }
Act2021Driver.AreaRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.AreaRankPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.AreaRankPanel.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeVector(1, this.vRankList);
};

Act2021Driver.AreaRankPanel.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.vRankList= is.readVector(1, false, this.vRankList);
};

Act2021Driver.DayRankPanel = function()
{
    this.iAreaId = 0;
    this.iDay = 0;
    this.vRankList = new Taf.Vector(new Act2021Driver.RankItem());
    this.iTopRank = 0;
};
Act2021Driver.DayRankPanel.prototype._clone = function () { return new Act2021Driver.DayRankPanel(); }
Act2021Driver.DayRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.DayRankPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.DayRankPanel.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iDay);
    os.writeVector(2, this.vRankList);
    os.writeInt32(3, this.iTopRank);
};

Act2021Driver.DayRankPanel.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iDay= is.readInt32(1, false, this.iDay);
    this.vRankList= is.readVector(2, false, this.vRankList);
    this.iTopRank= is.readInt32(3, false, this.iTopRank);
};

Act2021Driver.HourRankPanel = function()
{
    this.iAreaId = 0;
    this.iHour = 0;
    this.vRankList = new Taf.Vector(new Act2021Driver.RankItem());
};
Act2021Driver.HourRankPanel.prototype._clone = function () { return new Act2021Driver.HourRankPanel(); }
Act2021Driver.HourRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.HourRankPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.HourRankPanel.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iHour);
    os.writeVector(2, this.vRankList);
};

Act2021Driver.HourRankPanel.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iHour= is.readInt32(1, false, this.iHour);
    this.vRankList= is.readVector(2, false, this.vRankList);
};

Act2021Driver.PromoteResultPanel = function()
{
    this.lPid = 0;
    this.iPromoteType = 0;
    this.iAreaId = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
    this.iRank = 0;
    this.iCarColorId = 0;
    this.sCarUrl = "";
};
Act2021Driver.PromoteResultPanel.prototype._clone = function () { return new Act2021Driver.PromoteResultPanel(); }
Act2021Driver.PromoteResultPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.PromoteResultPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.PromoteResultPanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iPromoteType);
    os.writeInt32(2, this.iAreaId);
    os.writeString(3, this.sNickName);
    os.writeString(4, this.sLogoUrl);
    os.writeInt32(5, this.iRank);
    os.writeInt32(6, this.iCarColorId);
    os.writeString(7, this.sCarUrl);
};

Act2021Driver.PromoteResultPanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iPromoteType= is.readInt32(1, false, this.iPromoteType);
    this.iAreaId= is.readInt32(2, false, this.iAreaId);
    this.sNickName= is.readString(3, false, this.sNickName);
    this.sLogoUrl= is.readString(4, false, this.sLogoUrl);
    this.iRank= is.readInt32(5, false, this.iRank);
    this.iCarColorId= is.readInt32(6, false, this.iCarColorId);
    this.sCarUrl= is.readString(7, false, this.sCarUrl);
};

Act2021Driver.PresenterInfo = function()
{
    this.lPid = 0;
    this.iRank = 0;
    this.sLogoUrl = "";
    this.sNickName = "";
    this.tJump = new Act2021Driver.JumpChannel();
};
Act2021Driver.PresenterInfo.prototype._clone = function () { return new Act2021Driver.PresenterInfo(); }
Act2021Driver.PresenterInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.PresenterInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.PresenterInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iRank);
    os.writeString(2, this.sLogoUrl);
    os.writeString(3, this.sNickName);
    os.writeStruct(4, this.tJump);
};

Act2021Driver.PresenterInfo.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iRank= is.readInt32(1, false, this.iRank);
    this.sLogoUrl= is.readString(2, false, this.sLogoUrl);
    this.sNickName= is.readString(3, false, this.sNickName);
    this.tJump= is.readStruct(4, false, this.tJump);
};

Act2021Driver.HonorResultPanel = function()
{
    this.iAreaId = 0;
    this.vWinnerList = new Taf.Vector(new Act2021Driver.PresenterInfo());
};
Act2021Driver.HonorResultPanel.prototype._clone = function () { return new Act2021Driver.HonorResultPanel(); }
Act2021Driver.HonorResultPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.HonorResultPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.HonorResultPanel.prototype.writeTo = function (os)
{
    os.writeInt32(1, this.iAreaId);
    os.writeVector(2, this.vWinnerList);
};

Act2021Driver.HonorResultPanel.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(1, false, this.iAreaId);
    this.vWinnerList= is.readVector(2, false, this.vWinnerList);
};

Act2021Driver.AttackReq = function()
{
    this.tAttackId = new HUYA.UserId();
    this.lDefPid = 0;
};
Act2021Driver.AttackReq.prototype._clone = function () { return new Act2021Driver.AttackReq(); }
Act2021Driver.AttackReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.AttackReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.AttackReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tAttackId);
    os.writeInt64(1, this.lDefPid);
};

Act2021Driver.AttackReq.prototype.readFrom = function (is)
{
    this.tAttackId= is.readStruct(0, false, this.tAttackId);
    this.lDefPid= is.readInt64(1, false, this.lDefPid);
};

Act2021Driver.AttackRsp = function()
{
    this.iResult = 0;
    this.lAttPid = 0;
    this.lDefPid = 0;
    this.sDesc1 = "";
    this.sDesc2 = "";
};
Act2021Driver.AttackRsp.prototype._clone = function () { return new Act2021Driver.AttackRsp(); }
Act2021Driver.AttackRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.AttackRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.AttackRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iResult);
    os.writeInt64(1, this.lAttPid);
    os.writeInt64(2, this.lDefPid);
    os.writeString(3, this.sDesc1);
    os.writeString(4, this.sDesc2);
};

Act2021Driver.AttackRsp.prototype.readFrom = function (is)
{
    this.iResult= is.readInt32(0, false, this.iResult);
    this.lAttPid= is.readInt64(1, false, this.lAttPid);
    this.lDefPid= is.readInt64(2, false, this.lDefPid);
    this.sDesc1= is.readString(3, false, this.sDesc1);
    this.sDesc2= is.readString(4, false, this.sDesc2);
};

Act2021Driver.AttackSearchItem = function()
{
    this.lPid = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
    this.lScore = 0;
    this.iAttTime = 0;
    this.iDefTime = 0;
    this.iRevege = 0;
};
Act2021Driver.AttackSearchItem.prototype._clone = function () { return new Act2021Driver.AttackSearchItem(); }
Act2021Driver.AttackSearchItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.AttackSearchItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.AttackSearchItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sLogoUrl);
    os.writeInt64(3, this.lScore);
    os.writeInt32(4, this.iAttTime);
    os.writeInt32(5, this.iDefTime);
    os.writeInt32(6, this.iRevege);
};

Act2021Driver.AttackSearchItem.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.sLogoUrl= is.readString(2, false, this.sLogoUrl);
    this.lScore= is.readInt64(3, false, this.lScore);
    this.iAttTime= is.readInt32(4, false, this.iAttTime);
    this.iDefTime= is.readInt32(5, false, this.iDefTime);
    this.iRevege= is.readInt32(6, false, this.iRevege);
};

Act2021Driver.AttackSearchReq = function()
{
    this.lPid = 0;
    this.sSearchName = "";
};
Act2021Driver.AttackSearchReq.prototype._clone = function () { return new Act2021Driver.AttackSearchReq(); }
Act2021Driver.AttackSearchReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.AttackSearchReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.AttackSearchReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeString(1, this.sSearchName);
};

Act2021Driver.AttackSearchReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.sSearchName= is.readString(1, false, this.sSearchName);
};

Act2021Driver.AttackSearchRsp = function()
{
    this.vItems = new Taf.Vector(new Act2021Driver.AttackSearchItem());
};
Act2021Driver.AttackSearchRsp.prototype._clone = function () { return new Act2021Driver.AttackSearchRsp(); }
Act2021Driver.AttackSearchRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.AttackSearchRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.AttackSearchRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vItems);
};

Act2021Driver.AttackSearchRsp.prototype.readFrom = function (is)
{
    this.vItems= is.readVector(0, false, this.vItems);
};

Act2021Driver.BattleMember = function()
{
    this.tJump = new Act2021Driver.JumpChannel();
    this.sLogo = "";
    this.sNickName = "";
    this.iCarColorId = 0;
};
Act2021Driver.BattleMember.prototype._clone = function () { return new Act2021Driver.BattleMember(); }
Act2021Driver.BattleMember.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.BattleMember.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.BattleMember.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tJump);
    os.writeString(1, this.sLogo);
    os.writeString(2, this.sNickName);
    os.writeInt32(3, this.iCarColorId);
};

Act2021Driver.BattleMember.prototype.readFrom = function (is)
{
    this.tJump= is.readStruct(0, false, this.tJump);
    this.sLogo= is.readString(1, false, this.sLogo);
    this.sNickName= is.readString(2, false, this.sNickName);
    this.iCarColorId= is.readInt32(3, false, this.iCarColorId);
};

Act2021Driver.BattleUpdatePanel = function()
{
    this.iLeftTime = 0;
    this.iSide = 0;
    this.iKillTime = 0;
    this.lPid = 0;
    this.lAttScore = 0;
    this.iAttPkBuff = 0;
    this.iAttCarPos = 0;
    this.lDefScore = 0;
    this.iDefPkBuff = 0;
    this.iDefCarPos = 0;
};
Act2021Driver.BattleUpdatePanel.prototype._clone = function () { return new Act2021Driver.BattleUpdatePanel(); }
Act2021Driver.BattleUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.BattleUpdatePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.BattleUpdatePanel.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iLeftTime);
    os.writeInt32(1, this.iSide);
    os.writeInt32(2, this.iKillTime);
    os.writeInt64(3, this.lPid);
    os.writeInt64(4, this.lAttScore);
    os.writeInt32(5, this.iAttPkBuff);
    os.writeInt32(6, this.iAttCarPos);
    os.writeInt64(7, this.lDefScore);
    os.writeInt32(8, this.iDefPkBuff);
    os.writeInt32(9, this.iDefCarPos);
};

Act2021Driver.BattleUpdatePanel.prototype.readFrom = function (is)
{
    this.iLeftTime= is.readInt32(0, false, this.iLeftTime);
    this.iSide= is.readInt32(1, false, this.iSide);
    this.iKillTime= is.readInt32(2, false, this.iKillTime);
    this.lPid= is.readInt64(3, false, this.lPid);
    this.lAttScore= is.readInt64(4, false, this.lAttScore);
    this.iAttPkBuff= is.readInt32(5, false, this.iAttPkBuff);
    this.iAttCarPos= is.readInt32(6, false, this.iAttCarPos);
    this.lDefScore= is.readInt64(7, false, this.lDefScore);
    this.iDefPkBuff= is.readInt32(8, false, this.iDefPkBuff);
    this.iDefCarPos= is.readInt32(9, false, this.iDefCarPos);
};

Act2021Driver.BattlePanel = function()
{
    this.tUpdate = new Act2021Driver.BattleUpdatePanel();
    this.tAttUser = new Act2021Driver.BattleMember();
    this.tDefUser = new Act2021Driver.BattleMember();
    this.iPkType = 0;
    this.iType = 0;
    this.lAttReward = 0;
    this.lDefReward = 0;
    this.iAreaId = 0;
};
Act2021Driver.BattlePanel.prototype._clone = function () { return new Act2021Driver.BattlePanel(); }
Act2021Driver.BattlePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.BattlePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.BattlePanel.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUpdate);
    os.writeStruct(1, this.tAttUser);
    os.writeStruct(2, this.tDefUser);
    os.writeInt32(3, this.iPkType);
    os.writeInt32(4, this.iType);
    os.writeInt64(5, this.lAttReward);
    os.writeInt64(6, this.lDefReward);
    os.writeInt32(7, this.iAreaId);
};

Act2021Driver.BattlePanel.prototype.readFrom = function (is)
{
    this.tUpdate= is.readStruct(0, false, this.tUpdate);
    this.tAttUser= is.readStruct(1, false, this.tAttUser);
    this.tDefUser= is.readStruct(2, false, this.tDefUser);
    this.iPkType= is.readInt32(3, false, this.iPkType);
    this.iType= is.readInt32(4, false, this.iType);
    this.lAttReward= is.readInt64(5, false, this.lAttReward);
    this.lDefReward= is.readInt64(6, false, this.lDefReward);
    this.iAreaId= is.readInt32(7, false, this.iAreaId);
};

Act2021Driver.BattleAnnouncePanel = function()
{
    this.tBattle = new Act2021Driver.BattlePanel();
    this.iBuffCount = 0;
};
Act2021Driver.BattleAnnouncePanel.prototype._clone = function () { return new Act2021Driver.BattleAnnouncePanel(); }
Act2021Driver.BattleAnnouncePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.BattleAnnouncePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.BattleAnnouncePanel.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tBattle);
    os.writeInt32(1, this.iBuffCount);
};

Act2021Driver.BattleAnnouncePanel.prototype.readFrom = function (is)
{
    this.tBattle= is.readStruct(0, false, this.tBattle);
    this.iBuffCount= is.readInt32(1, false, this.iBuffCount);
};

Act2021Driver.BattleResultPanel = function()
{
    this.tBattle = new Act2021Driver.BattlePanel();
    this.iResult = 0;
    this.lDeltaScore = 0;
    this.lReturnScore = 0;
};
Act2021Driver.BattleResultPanel.prototype._clone = function () { return new Act2021Driver.BattleResultPanel(); }
Act2021Driver.BattleResultPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.BattleResultPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.BattleResultPanel.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tBattle);
    os.writeInt32(1, this.iResult);
    os.writeInt64(2, this.lDeltaScore);
    os.writeInt64(3, this.lReturnScore);
};

Act2021Driver.BattleResultPanel.prototype.readFrom = function (is)
{
    this.tBattle= is.readStruct(0, false, this.tBattle);
    this.iResult= is.readInt32(1, false, this.iResult);
    this.lDeltaScore= is.readInt64(2, false, this.lDeltaScore);
    this.lReturnScore= is.readInt64(3, false, this.lReturnScore);
};

Act2021Driver.EnablePkBuffReq = function()
{
    this.tPid = new HUYA.UserId();
};
Act2021Driver.EnablePkBuffReq.prototype._clone = function () { return new Act2021Driver.EnablePkBuffReq(); }
Act2021Driver.EnablePkBuffReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.EnablePkBuffReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.EnablePkBuffReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tPid);
};

Act2021Driver.EnablePkBuffReq.prototype.readFrom = function (is)
{
    this.tPid= is.readStruct(0, false, this.tPid);
};

Act2021Driver.EnablePkBuffRsp = function()
{
    this.iResult = 0;
    this.sErrMsg = "";
};
Act2021Driver.EnablePkBuffRsp.prototype._clone = function () { return new Act2021Driver.EnablePkBuffRsp(); }
Act2021Driver.EnablePkBuffRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.EnablePkBuffRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.EnablePkBuffRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iResult);
    os.writeString(1, this.sErrMsg);
};

Act2021Driver.EnablePkBuffRsp.prototype.readFrom = function (is)
{
    this.iResult= is.readInt32(0, false, this.iResult);
    this.sErrMsg= is.readString(1, false, this.sErrMsg);
};

Act2021Driver.FansScore = function()
{
    this.lUid = 0;
    this.sNickName = "";
    this.lScore = 0;
};
Act2021Driver.FansScore.prototype._clone = function () { return new Act2021Driver.FansScore(); }
Act2021Driver.FansScore.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.FansScore.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.FansScore.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
    os.writeInt64(3, this.lScore);
};

Act2021Driver.FansScore.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.lScore= is.readInt64(3, false, this.lScore);
};

Act2021Driver.BattleFansScorePanel = function()
{
    this.lPid = 0;
    this.vAttScores = new Taf.Vector(new Act2021Driver.FansScore());
    this.vDefScores = new Taf.Vector(new Act2021Driver.FansScore());
};
Act2021Driver.BattleFansScorePanel.prototype._clone = function () { return new Act2021Driver.BattleFansScorePanel(); }
Act2021Driver.BattleFansScorePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.BattleFansScorePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.BattleFansScorePanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeVector(1, this.vAttScores);
    os.writeVector(2, this.vDefScores);
};

Act2021Driver.BattleFansScorePanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.vAttScores= is.readVector(1, false, this.vAttScores);
    this.vDefScores= is.readVector(2, false, this.vDefScores);
};

Act2021Driver.ClearPanel = function()
{
    this.lPid = 0;
    this.iActivityId = 0;
};
Act2021Driver.ClearPanel.prototype._clone = function () { return new Act2021Driver.ClearPanel(); }
Act2021Driver.ClearPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.ClearPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.ClearPanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iActivityId);
};

Act2021Driver.ClearPanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iActivityId= is.readInt32(1, false, this.iActivityId);
};

Act2021Driver.ActivePkPanel = function()
{
    this.lPid = 0;
    this.iUseCount = 0;
    this.iTotalCount = 0;
    this.iCoolDown = 0;
};
Act2021Driver.ActivePkPanel.prototype._clone = function () { return new Act2021Driver.ActivePkPanel(); }
Act2021Driver.ActivePkPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.ActivePkPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.ActivePkPanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iUseCount);
    os.writeInt32(2, this.iTotalCount);
    os.writeInt32(3, this.iCoolDown);
};

Act2021Driver.ActivePkPanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iUseCount= is.readInt32(1, false, this.iUseCount);
    this.iTotalCount= is.readInt32(2, false, this.iTotalCount);
    this.iCoolDown= is.readInt32(3, false, this.iCoolDown);
};

Act2021Driver.UserTaskState = function()
{
    this.lTaskId = 0;
    this.sTaskDesc = "";
    this.iState = 0;
    this.iTaskLevel = 0;
    this.iNowExperience = 0;
    this.iNextExperience = 0;
    this.iFinishedTimes = 0;
};
Act2021Driver.UserTaskState.prototype._clone = function () { return new Act2021Driver.UserTaskState(); }
Act2021Driver.UserTaskState.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.UserTaskState.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.UserTaskState.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lTaskId);
    os.writeString(1, this.sTaskDesc);
    os.writeInt32(2, this.iState);
    os.writeInt32(3, this.iTaskLevel);
    os.writeInt32(4, this.iNowExperience);
    os.writeInt32(5, this.iNextExperience);
    os.writeInt32(6, this.iFinishedTimes);
};

Act2021Driver.UserTaskState.prototype.readFrom = function (is)
{
    this.lTaskId= is.readInt64(0, false, this.lTaskId);
    this.sTaskDesc= is.readString(1, false, this.sTaskDesc);
    this.iState= is.readInt32(2, false, this.iState);
    this.iTaskLevel= is.readInt32(3, false, this.iTaskLevel);
    this.iNowExperience= is.readInt32(4, false, this.iNowExperience);
    this.iNextExperience= is.readInt32(5, false, this.iNextExperience);
    this.iFinishedTimes= is.readInt32(6, false, this.iFinishedTimes);
};

Act2021Driver.TaskUpdatePanel = function()
{
    this.lPid = 0;
    this.lTopTaskId = 0;
    this.vTaskList = new Taf.Vector(new Act2021Driver.UserTaskState());
};
Act2021Driver.TaskUpdatePanel.prototype._clone = function () { return new Act2021Driver.TaskUpdatePanel(); }
Act2021Driver.TaskUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.TaskUpdatePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.TaskUpdatePanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lTopTaskId);
    os.writeVector(2, this.vTaskList);
};

Act2021Driver.TaskUpdatePanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.lTopTaskId= is.readInt64(1, false, this.lTopTaskId);
    this.vTaskList= is.readVector(2, false, this.vTaskList);
};

Act2021Driver.SingleTaskUpdatePanel = function()
{
    this.lPid = 0;
    this.tTaskItem = new Act2021Driver.UserTaskState();
};
Act2021Driver.SingleTaskUpdatePanel.prototype._clone = function () { return new Act2021Driver.SingleTaskUpdatePanel(); }
Act2021Driver.SingleTaskUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.SingleTaskUpdatePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.SingleTaskUpdatePanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeStruct(1, this.tTaskItem);
};

Act2021Driver.SingleTaskUpdatePanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.tTaskItem= is.readStruct(1, false, this.tTaskItem);
};

Act2021Driver.TopTaskReq = function()
{
    this.lPid = 0;
    this.lTaskId = 0;
};
Act2021Driver.TopTaskReq.prototype._clone = function () { return new Act2021Driver.TopTaskReq(); }
Act2021Driver.TopTaskReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.TopTaskReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.TopTaskReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lTaskId);
};

Act2021Driver.TopTaskReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.lTaskId= is.readInt64(1, false, this.lTaskId);
};

Act2021Driver.TopTaskRsp = function()
{
    this.iResult = 0;
    this.sMsg = "";
};
Act2021Driver.TopTaskRsp.prototype._clone = function () { return new Act2021Driver.TopTaskRsp(); }
Act2021Driver.TopTaskRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.TopTaskRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.TopTaskRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iResult);
    os.writeString(1, this.sMsg);
};

Act2021Driver.TopTaskRsp.prototype.readFrom = function (is)
{
    this.iResult= is.readInt32(0, false, this.iResult);
    this.sMsg= is.readString(1, false, this.sMsg);
};

Act2021Driver.MatchInfoReq = function()
{
    this.lPid = 0;
};
Act2021Driver.MatchInfoReq.prototype._clone = function () { return new Act2021Driver.MatchInfoReq(); }
Act2021Driver.MatchInfoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.MatchInfoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.MatchInfoReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
};

Act2021Driver.MatchInfoReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
};

Act2021Driver.MatchInfoRsp = function()
{
    this.iStage = 0;
    this.iStageDay = 0;
    this.iDay = 0;
    this.iHour = 0;
    this.iAreaId = 0;
};
Act2021Driver.MatchInfoRsp.prototype._clone = function () { return new Act2021Driver.MatchInfoRsp(); }
Act2021Driver.MatchInfoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.MatchInfoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.MatchInfoRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iStage);
    os.writeInt32(1, this.iStageDay);
    os.writeInt32(2, this.iDay);
    os.writeInt32(3, this.iHour);
    os.writeInt32(4, this.iAreaId);
};

Act2021Driver.MatchInfoRsp.prototype.readFrom = function (is)
{
    this.iStage= is.readInt32(0, false, this.iStage);
    this.iStageDay= is.readInt32(1, false, this.iStageDay);
    this.iDay= is.readInt32(2, false, this.iDay);
    this.iHour= is.readInt32(3, false, this.iHour);
    this.iAreaId= is.readInt32(4, false, this.iAreaId);
};

Act2021Driver.DiyCarReq = function()
{
    this.lPid = 0;
    this.iCarColorId = 0;
};
Act2021Driver.DiyCarReq.prototype._clone = function () { return new Act2021Driver.DiyCarReq(); }
Act2021Driver.DiyCarReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.DiyCarReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.DiyCarReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iCarColorId);
};

Act2021Driver.DiyCarReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iCarColorId= is.readInt32(1, false, this.iCarColorId);
};

Act2021Driver.DiyCarRsp = function()
{
    this.iRet = 0;
    this.sMsg = "";
};
Act2021Driver.DiyCarRsp.prototype._clone = function () { return new Act2021Driver.DiyCarRsp(); }
Act2021Driver.DiyCarRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.DiyCarRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.DiyCarRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRet);
    os.writeString(1, this.sMsg);
};

Act2021Driver.DiyCarRsp.prototype.readFrom = function (is)
{
    this.iRet= is.readInt32(0, false, this.iRet);
    this.sMsg= is.readString(1, false, this.sMsg);
};

Act2021Driver.LotteryInfoPanel = function()
{
    this.lPid = 0;
    this.iTotalBox = 0;
    this.iLeftBox = 0;
    this.iSuperFansTimes = 0;
    this.iDiamondFansTimes = 0;
    this.iLacquerTimes = 0;
};
Act2021Driver.LotteryInfoPanel.prototype._clone = function () { return new Act2021Driver.LotteryInfoPanel(); }
Act2021Driver.LotteryInfoPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.LotteryInfoPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.LotteryInfoPanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iTotalBox);
    os.writeInt32(2, this.iLeftBox);
    os.writeInt32(3, this.iSuperFansTimes);
    os.writeInt32(4, this.iDiamondFansTimes);
    os.writeInt32(5, this.iLacquerTimes);
};

Act2021Driver.LotteryInfoPanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iTotalBox= is.readInt32(1, false, this.iTotalBox);
    this.iLeftBox= is.readInt32(2, false, this.iLeftBox);
    this.iSuperFansTimes= is.readInt32(3, false, this.iSuperFansTimes);
    this.iDiamondFansTimes= is.readInt32(4, false, this.iDiamondFansTimes);
    this.iLacquerTimes= is.readInt32(5, false, this.iLacquerTimes);
};

Act2021Driver.LotteryRecord = function()
{
    this.lLotteryTime = 0;
    this.iBonusType = 0;
    this.sBonusName = "";
};
Act2021Driver.LotteryRecord.prototype._clone = function () { return new Act2021Driver.LotteryRecord(); }
Act2021Driver.LotteryRecord.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.LotteryRecord.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.LotteryRecord.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lLotteryTime);
    os.writeInt32(1, this.iBonusType);
    os.writeString(2, this.sBonusName);
};

Act2021Driver.LotteryRecord.prototype.readFrom = function (is)
{
    this.lLotteryTime= is.readInt64(0, false, this.lLotteryTime);
    this.iBonusType= is.readInt32(1, false, this.iBonusType);
    this.sBonusName= is.readString(2, false, this.sBonusName);
};

Act2021Driver.LotteryRecordPanel = function()
{
    this.lPid = 0;
    this.vLotteryList = new Taf.Vector(new Act2021Driver.LotteryRecord());
};
Act2021Driver.LotteryRecordPanel.prototype._clone = function () { return new Act2021Driver.LotteryRecordPanel(); }
Act2021Driver.LotteryRecordPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.LotteryRecordPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.LotteryRecordPanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeVector(1, this.vLotteryList);
};

Act2021Driver.LotteryRecordPanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.vLotteryList= is.readVector(1, false, this.vLotteryList);
};

Act2021Driver.OpenBoxReq = function()
{
    this.tPid = new HUYA.UserId();
};
Act2021Driver.OpenBoxReq.prototype._clone = function () { return new Act2021Driver.OpenBoxReq(); }
Act2021Driver.OpenBoxReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.OpenBoxReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.OpenBoxReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tPid);
};

Act2021Driver.OpenBoxReq.prototype.readFrom = function (is)
{
    this.tPid= is.readStruct(0, false, this.tPid);
};

Act2021Driver.OpenBoxRsp = function()
{
    this.iRet = 0;
    this.sMsg = "";
    this.iBonusType = 0;
    this.iTotalBox = 0;
    this.iLeftBox = 0;
};
Act2021Driver.OpenBoxRsp.prototype._clone = function () { return new Act2021Driver.OpenBoxRsp(); }
Act2021Driver.OpenBoxRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.OpenBoxRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.OpenBoxRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRet);
    os.writeString(1, this.sMsg);
    os.writeInt32(2, this.iBonusType);
    os.writeInt32(3, this.iTotalBox);
    os.writeInt32(4, this.iLeftBox);
};

Act2021Driver.OpenBoxRsp.prototype.readFrom = function (is)
{
    this.iRet= is.readInt32(0, false, this.iRet);
    this.sMsg= is.readString(1, false, this.sMsg);
    this.iBonusType= is.readInt32(2, false, this.iBonusType);
    this.iTotalBox= is.readInt32(3, false, this.iTotalBox);
    this.iLeftBox= is.readInt32(4, false, this.iLeftBox);
};

Act2021Driver.StageReq = function()
{
    this.iDummy = 0;
    this.lPid = 0;
};
Act2021Driver.StageReq.prototype._clone = function () { return new Act2021Driver.StageReq(); }
Act2021Driver.StageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.StageReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.StageReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iDummy);
    os.writeInt64(1, this.lPid);
};

Act2021Driver.StageReq.prototype.readFrom = function (is)
{
    this.iDummy= is.readInt32(0, false, this.iDummy);
    this.lPid= is.readInt64(1, false, this.lPid);
};

Act2021Driver.StageRsp = function()
{
    this.iStage = 0;
    this.iAreaId = 0;
};
Act2021Driver.StageRsp.prototype._clone = function () { return new Act2021Driver.StageRsp(); }
Act2021Driver.StageRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.StageRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.StageRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iStage);
    os.writeInt32(1, this.iAreaId);
};

Act2021Driver.StageRsp.prototype.readFrom = function (is)
{
    this.iStage= is.readInt32(0, false, this.iStage);
    this.iAreaId= is.readInt32(1, false, this.iAreaId);
};

Act2021Driver.DayRankReq = function()
{
    this.lPid = 0;
    this.iAreaId = 0;
};
Act2021Driver.DayRankReq.prototype._clone = function () { return new Act2021Driver.DayRankReq(); }
Act2021Driver.DayRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.DayRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.DayRankReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iAreaId);
};

Act2021Driver.DayRankReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iAreaId= is.readInt32(1, false, this.iAreaId);
};

Act2021Driver.DayRankRsp = function()
{
    this.vItem = new Taf.Vector(new Act2021Driver.RankItem());
    this.tItem = new Act2021Driver.RankItem();
};
Act2021Driver.DayRankRsp.prototype._clone = function () { return new Act2021Driver.DayRankRsp(); }
Act2021Driver.DayRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.DayRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.DayRankRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vItem);
    os.writeStruct(1, this.tItem);
};

Act2021Driver.DayRankRsp.prototype.readFrom = function (is)
{
    this.vItem= is.readVector(0, false, this.vItem);
    this.tItem= is.readStruct(1, false, this.tItem);
};

Act2021Driver.DriverRankReq = function()
{
    this.lPid = 0;
    this.iAreaId = 0;
};
Act2021Driver.DriverRankReq.prototype._clone = function () { return new Act2021Driver.DriverRankReq(); }
Act2021Driver.DriverRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.DriverRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.DriverRankReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iAreaId);
};

Act2021Driver.DriverRankReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iAreaId= is.readInt32(1, false, this.iAreaId);
};

Act2021Driver.DriverRankRsp = function()
{
    this.vItem = new Taf.Vector(new Act2021Driver.RankItem());
    this.tItem = new Act2021Driver.RankItem();
};
Act2021Driver.DriverRankRsp.prototype._clone = function () { return new Act2021Driver.DriverRankRsp(); }
Act2021Driver.DriverRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.DriverRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.DriverRankRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vItem);
    os.writeStruct(1, this.tItem);
};

Act2021Driver.DriverRankRsp.prototype.readFrom = function (is)
{
    this.vItem= is.readVector(0, false, this.vItem);
    this.tItem= is.readStruct(1, false, this.tItem);
};

Act2021Driver.RichRankReq = function()
{
    this.lPid = 0;
};
Act2021Driver.RichRankReq.prototype._clone = function () { return new Act2021Driver.RichRankReq(); }
Act2021Driver.RichRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.RichRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.RichRankReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
};

Act2021Driver.RichRankReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
};

Act2021Driver.RichRankRsp = function()
{
    this.vItem = new Taf.Vector(new Act2021Driver.RankItem());
};
Act2021Driver.RichRankRsp.prototype._clone = function () { return new Act2021Driver.RichRankRsp(); }
Act2021Driver.RichRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.RichRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.RichRankRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vItem);
};

Act2021Driver.RichRankRsp.prototype.readFrom = function (is)
{
    this.vItem= is.readVector(0, false, this.vItem);
};

Act2021Driver.AwardRecordReq = function()
{
    this.lPid = 0;
};
Act2021Driver.AwardRecordReq.prototype._clone = function () { return new Act2021Driver.AwardRecordReq(); }
Act2021Driver.AwardRecordReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.AwardRecordReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.AwardRecordReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
};

Act2021Driver.AwardRecordReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
};

Act2021Driver.AwardEvent = function()
{
    this.sNickName = "";
    this.sMsg = "";
    this.lLotteryTime = 0;
};
Act2021Driver.AwardEvent.prototype._clone = function () { return new Act2021Driver.AwardEvent(); }
Act2021Driver.AwardEvent.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.AwardEvent.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.AwardEvent.prototype.writeTo = function (os)
{
    os.writeString(0, this.sNickName);
    os.writeString(1, this.sMsg);
    os.writeInt64(2, this.lLotteryTime);
};

Act2021Driver.AwardEvent.prototype.readFrom = function (is)
{
    this.sNickName= is.readString(0, false, this.sNickName);
    this.sMsg= is.readString(1, false, this.sMsg);
    this.lLotteryTime= is.readInt64(2, false, this.lLotteryTime);
};

Act2021Driver.AwardRecordRsp = function()
{
    this.vEvents = new Taf.Vector(new Act2021Driver.AwardEvent());
};
Act2021Driver.AwardRecordRsp.prototype._clone = function () { return new Act2021Driver.AwardRecordRsp(); }
Act2021Driver.AwardRecordRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.AwardRecordRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.AwardRecordRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vEvents);
};

Act2021Driver.AwardRecordRsp.prototype.readFrom = function (is)
{
    this.vEvents= is.readVector(0, false, this.vEvents);
};

Act2021Driver.HourRankReq = function()
{
    this.lPid = 0;
    this.iAreaId = 0;
};
Act2021Driver.HourRankReq.prototype._clone = function () { return new Act2021Driver.HourRankReq(); }
Act2021Driver.HourRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.HourRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.HourRankReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iAreaId);
};

Act2021Driver.HourRankReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iAreaId= is.readInt32(1, false, this.iAreaId);
};

Act2021Driver.HourRankRsp = function()
{
    this.iHour = 0;
    this.vItem = new Taf.Vector(new Act2021Driver.RankItem());
    this.tItem = new Act2021Driver.RankItem();
};
Act2021Driver.HourRankRsp.prototype._clone = function () { return new Act2021Driver.HourRankRsp(); }
Act2021Driver.HourRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.HourRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.HourRankRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iHour);
    os.writeVector(1, this.vItem);
    os.writeStruct(2, this.tItem);
};

Act2021Driver.HourRankRsp.prototype.readFrom = function (is)
{
    this.iHour= is.readInt32(0, false, this.iHour);
    this.vItem= is.readVector(1, false, this.vItem);
    this.tItem= is.readStruct(2, false, this.tItem);
};

Act2021Driver.HourChampionReq = function()
{
    this.lPid = 0;
    this.iAreaId = 0;
};
Act2021Driver.HourChampionReq.prototype._clone = function () { return new Act2021Driver.HourChampionReq(); }
Act2021Driver.HourChampionReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.HourChampionReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.HourChampionReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iAreaId);
};

Act2021Driver.HourChampionReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iAreaId= is.readInt32(1, false, this.iAreaId);
};

Act2021Driver.HourRankItem = function()
{
    this.iHour = 0;
    this.tItem = new Act2021Driver.RankItem();
};
Act2021Driver.HourRankItem.prototype._clone = function () { return new Act2021Driver.HourRankItem(); }
Act2021Driver.HourRankItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.HourRankItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.HourRankItem.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iHour);
    os.writeStruct(1, this.tItem);
};

Act2021Driver.HourRankItem.prototype.readFrom = function (is)
{
    this.iHour= is.readInt32(0, false, this.iHour);
    this.tItem= is.readStruct(1, false, this.tItem);
};

Act2021Driver.HourChampionRsp = function()
{
    this.vItem = new Taf.Vector(new Act2021Driver.HourRankItem());
};
Act2021Driver.HourChampionRsp.prototype._clone = function () { return new Act2021Driver.HourChampionRsp(); }
Act2021Driver.HourChampionRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2021Driver.HourChampionRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2021Driver.HourChampionRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vItem);
};

Act2021Driver.HourChampionRsp.prototype.readFrom = function (is)
{
    this.vItem= is.readVector(0, false, this.vItem);
};

export default Act2021Driver;
